webpackJsonp([1],{

/***/ 1169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1183:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1186:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1184)

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(1399),
  /* scopeId */
  "data-v-4b04fc2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1187)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1402),
  /* scopeId */
  "data-v-5adbbd04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1192)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1407),
  /* scopeId */
  "data-v-7cef3226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1175)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1386),
  /* scopeId */
  "data-v-18e3b7d3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1193)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1408),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1169)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1380),
  /* scopeId */
  "data-v-08c535c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1174)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1385),
  /* scopeId */
  "data-v-181778f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1191)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1406),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1180)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1394),
  /* scopeId */
  "data-v-36a6d58c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1173)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1384),
  /* scopeId */
  "data-v-11b65c59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1195)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1411),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1179)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1392),
  /* scopeId */
  "data-v-296985b9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1197)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1413),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1188)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1403),
  /* scopeId */
  "data-v-5b7394e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1176)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1387),
  /* scopeId */
  "data-v-1d70e918",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1178)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1186)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1401),
  /* scopeId */
  "data-v-54ae581f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1398),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(1391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(1410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1177)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1388),
  /* scopeId */
  "data-v-1e0440f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1171)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1382),
  /* scopeId */
  "data-v-0ed5316b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1182)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1396),
  /* scopeId */
  "data-v-432a0e64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1198)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1414),
  /* scopeId */
  "data-v-db806210",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1194)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1409),
  /* scopeId */
  "data-v-8c154026",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1181)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1395),
  /* scopeId */
  "data-v-390cfdba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1190)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1405),
  /* scopeId */
  "data-v-61043dc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1185)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1400),
  /* scopeId */
  "data-v-4e977841",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1170)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1381),
  /* scopeId */
  "data-v-0ac31e07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1199)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1415),
  /* scopeId */
  "data-v-f538c34c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1183)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1397),
  /* scopeId */
  "data-v-44573181",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1189)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1404),
  /* scopeId */
  "data-v-5ca2f128",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1172)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1383),
  /* scopeId */
  "data-v-0f5de6a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.collapsed ? "" :
    _vm.sysName))]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "left",
      "font-size": "15px",
      "margin-left": "20px"
    },
    attrs: {
      "span": 8
    }
  }, [(_vm.userBillingDue <= 0) ? _c('div', [_c('el-button', {
    staticStyle: {
      "color": "white",
      "background-color": "red",
      "font-size": "15px"
    },
    attrs: {
      "type": "danger",
      "effect": "dark"
    },
    on: {
      "click": _vm.billingDueClick
    }
  }, [_vm._v("Cloud subscription payment due!")])], 1) : (_vm.userBillingDue <= 30) ? _c('div', [_c('el-button', {
    staticStyle: {
      "color": "white",
      "background-color": "orange",
      "font-size": "15px"
    },
    attrs: {
      "type": "warning",
      "effect": "dark"
    },
    on: {
      "click": _vm.billingDueClick
    }
  }, [_vm._v("Cloud subscription payment due\n            soon!")])], 1) : _c('div', [_vm._v(_vm._s(_vm.currentDateTime))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 6
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v("\n            " + _vm._s(_vm.zone.name) + "\n          ")]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.user.role == 'admin') ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('Zones')
      }
    }
  }, [_vm._v("Manage\n              Zones")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.profileClick($event)
      }
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$auth.logout()
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v("\n              " + _vm._s(item.children[0].name) + "\n            ")]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(child.name) + "\n                ")]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Boiler",
      "name": "boiler"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Boiler Pressure: " + _vm._s(_vm.boilerForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.boilerForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.boilerForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "enabled", $$v)
      },
      expression: "boilerForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "calibrationAdjustment", $$v)
      },
      expression: "boilerForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "rangeHigh", $$v)
      },
      expression: "boilerForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "rangeLow", $$v)
      },
      expression: "boilerForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Supply",
      "name": "supply"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Supply Pressure: " + _vm._s(_vm.supplyForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.supplyForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.supplyForm.allowControlEnabled
    },
    model: {
      value: (_vm.supplyForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "enabled", $$v)
      },
      expression: "supplyForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "calibrationAdjustment", $$v)
      },
      expression: "supplyForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "rangeHigh", $$v)
      },
      expression: "supplyForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "rangeLow", $$v)
      },
      expression: "supplyForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Return",
      "name": "return"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Return Pressure: " + _vm._s(_vm.returnForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.returnForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.returnForm.allowControlEnabled
    },
    model: {
      value: (_vm.returnForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "enabled", $$v)
      },
      expression: "returnForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "calibrationAdjustment", $$v)
      },
      expression: "returnForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "rangeHigh", $$v)
      },
      expression: "returnForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "rangeLow", $$v)
      },
      expression: "returnForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1382:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "130px",
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Winter Auto Start"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.winterEnabled),
      callback: function($$v) {
        _vm.winterEnabled = $$v
      },
      expression: "winterEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Start"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.winterStartMonthChanged
    },
    model: {
      value: (_vm.winterStartMonth),
      callback: function($$v) {
        _vm.winterStartMonth = $$v
      },
      expression: "winterStartMonth"
    }
  }, _vm._l((_vm.winterStartStopMonthOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [(_vm.renderWinterStartDaySelect) ? _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.winterStartDayChanged
    },
    model: {
      value: (_vm.winterStartDay),
      callback: function($$v) {
        _vm.winterStartDay = $$v
      },
      expression: "winterStartDay"
    }
  }, _vm._l((_vm.winterStartDayOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Stop"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.winterStopMonthChanged
    },
    model: {
      value: (_vm.winterStopMonth),
      callback: function($$v) {
        _vm.winterStopMonth = $$v
      },
      expression: "winterStopMonth"
    }
  }, _vm._l((_vm.winterStartStopMonthOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [(_vm.renderWinterStopDaySelect) ? _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.winterStopDayChanged
    },
    model: {
      value: (_vm.winterStopDay),
      callback: function($$v) {
        _vm.winterStopDay = $$v
      },
      expression: "winterStopDay"
    }
  }, _vm._l((_vm.winterStopDayOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Auto Heat Adjust Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.autoHeatAdjustEnabled),
      callback: function($$v) {
        _vm.autoHeatAdjustEnabled = $$v
      },
      expression: "autoHeatAdjustEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ramp Up Speed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.rampUpSpeed),
      callback: function($$v) {
        _vm.rampUpSpeed = $$v
      },
      expression: "rampUpSpeed"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ramp Down Speed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.rampDownSpeed),
      callback: function($$v) {
        _vm.rampDownSpeed = $$v
      },
      expression: "rampDownSpeed"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "118px",
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Heatup Adjustment (+%)"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Heatup Adjustment",
      "type": "number"
    },
    model: {
      value: (_vm.heatup.adjustment),
      callback: function($$v) {
        _vm.$set(_vm.heatup, "adjustment", $$v)
      },
      expression: "heatup.adjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Start"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '02:00',
        step: '00:15',
        end: '11:30'
      },
      "placeholder": "Start"
    },
    on: {
      "change": _vm.HeatUpStartChange
    },
    model: {
      value: (_vm.heatup.start),
      callback: function($$v) {
        _vm.$set(_vm.heatup, "start", $$v)
      },
      expression: "heatup.start"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Duration"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '08:30'
      },
      "placeholder": "Duration"
    },
    on: {
      "change": _vm.HeatUpDurationChange
    },
    model: {
      value: (_vm.heatup.duration),
      callback: function($$v) {
        _vm.$set(_vm.heatup, "duration", $$v)
      },
      expression: "heatup.duration"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "118px",
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Midday Adjustment (-%)"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Heatup Adjustment",
      "type": "number"
    },
    model: {
      value: (_vm.midday.adjustment),
      callback: function($$v) {
        _vm.$set(_vm.midday, "adjustment", $$v)
      },
      expression: "midday.adjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Start"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '08:30',
        step: '00:15',
        end: '18:30'
      },
      "placeholder": "Start"
    },
    on: {
      "change": _vm.MiddayStartChange
    },
    model: {
      value: (_vm.midday.start),
      callback: function($$v) {
        _vm.$set(_vm.midday, "start", $$v)
      },
      expression: "midday.start"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Duration"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '08:00'
      },
      "placeholder": "Duration"
    },
    on: {
      "change": _vm.MiddayDurationChange
    },
    model: {
      value: (_vm.midday.duration),
      callback: function($$v) {
        _vm.$set(_vm.midday, "duration", $$v)
      },
      expression: "midday.duration"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "130px",
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Night Adjustment (-%)"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "Heatup Adjustment",
      "type": "number"
    },
    model: {
      value: (_vm.night.adjustment),
      callback: function($$v) {
        _vm.$set(_vm.night, "adjustment", $$v)
      },
      expression: "night.adjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Start"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '15:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Start"
    },
    on: {
      "change": _vm.NightStartChange
    },
    model: {
      value: (_vm.night.start),
      callback: function($$v) {
        _vm.$set(_vm.night, "start", $$v)
      },
      expression: "night.start"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('light-timeline', {
    attrs: {
      "items": _vm.timelineItems
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "118px",
      "width": "100%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1383:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Outdoor",
      "name": "outdoor"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Outdoor Temperature: " + _vm._s(_vm.outdoorForm.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.outdoorForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.outdoorForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.outdoorForm, "enabled", $$v)
      },
      expression: "outdoorForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.outdoorForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.outdoorForm, "calibrationAdjustment", $$v)
      },
      expression: "outdoorForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.outdoorForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.outdoorForm, "rangeHigh", $$v)
      },
      expression: "outdoorForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.outdoorForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.outdoorForm, "rangeLow", $$v)
      },
      expression: "outdoorForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Domestic Water",
      "name": "domesticWater"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Domestic Water Temperature: " + _vm._s(_vm.domesticForm.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.domesticForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.domesticForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.domesticForm, "enabled", $$v)
      },
      expression: "domesticForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domesticForm.enabled),
      expression: "domesticForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.domesticForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.domesticForm, "calibrationAdjustment", $$v)
      },
      expression: "domesticForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domesticForm.enabled),
      expression: "domesticForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.domesticForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.domesticForm, "rangeHigh", $$v)
      },
      expression: "domesticForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domesticForm.enabled),
      expression: "domesticForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.domesticForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.domesticForm, "rangeLow", $$v)
      },
      expression: "domesticForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Stack",
      "name": "stack"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Stack Temperature: " + _vm._s(_vm.stackForm.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.stackForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.stackForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.stackForm, "enabled", $$v)
      },
      expression: "stackForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stackForm.enabled),
      expression: "stackForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.stackForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.stackForm, "calibrationAdjustment", $$v)
      },
      expression: "stackForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stackForm.enabled),
      expression: "stackForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.stackForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.stackForm, "rangeHigh", $$v)
      },
      expression: "stackForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stackForm.enabled),
      expression: "stackForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.stackForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.stackForm, "rangeLow", $$v)
      },
      expression: "stackForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Return line",
      "name": "returnLine"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Return Line Temperature: " + _vm._s(_vm.returnLineForm.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.returnLineForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.returnLineForm.allowControlEnabled
    },
    model: {
      value: (_vm.returnLineForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.returnLineForm, "enabled", $$v)
      },
      expression: "returnLineForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnLineForm.enabled),
      expression: "returnLineForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnLineForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.returnLineForm, "calibrationAdjustment", $$v)
      },
      expression: "returnLineForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnLineForm.enabled),
      expression: "returnLineForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnLineForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.returnLineForm, "rangeHigh", $$v)
      },
      expression: "returnLineForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnLineForm.enabled),
      expression: "returnLineForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnLineForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.returnLineForm, "rangeLow", $$v)
      },
      expression: "returnLineForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Auxiliary",
      "name": "aux"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Auxiliary Temperature: " + _vm._s(_vm.auxiliaryForm.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.auxiliaryForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.auxiliaryForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.auxiliaryForm, "enabled", $$v)
      },
      expression: "auxiliaryForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auxiliaryForm.enabled),
      expression: "auxiliaryForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.auxiliaryForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.auxiliaryForm, "calibrationAdjustment", $$v)
      },
      expression: "auxiliaryForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auxiliaryForm.enabled),
      expression: "auxiliaryForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.auxiliaryForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.auxiliaryForm, "rangeHigh", $$v)
      },
      expression: "auxiliaryForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auxiliaryForm.enabled),
      expression: "auxiliaryForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.auxiliaryForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.auxiliaryForm, "rangeLow", $$v)
      },
      expression: "auxiliaryForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Heat Balancer",
      "name": "heatBalancer"
    }
  }, [(_vm.heatBalancerForm.enabled) ? _c('div', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_c('h2', [_vm._v("Heat Balancer Difference: " + _vm._s(_vm.heatBalancerForm.difference))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "s": "",
      "model": _vm.heatBalancerForm,
      "label-width": "100px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.heatBalancerForm.allowControlEnabled
    },
    model: {
      value: (_vm.heatBalancerForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm, "enabled", $$v)
      },
      expression: "heatBalancerForm.enabled"
    }
  })], 1)], 1), _vm._v(" "), (_vm.heatBalancerForm.enabled) ? _c('el-tabs', {
    model: {
      value: (_vm.heatBalancerActiveName),
      callback: function($$v) {
        _vm.heatBalancerActiveName = $$v
      },
      expression: "heatBalancerActiveName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Top",
      "name": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Heat Balancer Top: " + _vm._s(_vm.heatBalancerForm.top.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.heatBalancerForm.top,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.top.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.top, "calibrationAdjustment", $$v)
      },
      expression: "heatBalancerForm.top.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.top.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.top, "rangeHigh", $$v)
      },
      expression: "heatBalancerForm.top.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.top.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.top, "rangeLow", $$v)
      },
      expression: "heatBalancerForm.top.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Bottom",
      "name": "bottom"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Heat Balancer Bottom: " + _vm._s(_vm.heatBalancerForm.bottom.currentTemperature))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.heatBalancerForm.bottom,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.bottom.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.bottom, "calibrationAdjustment", $$v)
      },
      expression: "heatBalancerForm.bottom.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.bottom.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.bottom, "rangeHigh", $$v)
      },
      expression: "heatBalancerForm.bottom.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.heatBalancerForm.bottom.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.heatBalancerForm.bottom, "rangeLow", $$v)
      },
      expression: "heatBalancerForm.bottom.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1384:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterUsers
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "User Email",
      "min-width": 25,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "Role",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zone_name",
      "label": "Active Zone",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": 25
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userZonesClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Zones")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userDeleteClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userDeleteDialog.title,
      "visible": _vm.userDeleteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userDeleteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userDeleteDialog.loading),
      expression: "userDeleteDialog.loading"
    }],
    attrs: {
      "model": _vm.userDeleteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userDeleteDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userDeleteDialog.form, "email", $$v)
      },
      expression: "userDeleteDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userDeleteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.userDeleteDialogClick()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userZonesDialog.title,
      "visible": _vm.userZonesDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userZonesDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userZonesDialog.loading),
      expression: "userZonesDialog.loading"
    }],
    attrs: {
      "model": _vm.userZonesDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userZonesDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userZonesDialog.form, "email", $$v)
      },
      expression: "userZonesDialog.form.email"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.userZonesDialog.form.zones), function(zone) {
    return _c('el-tag', {
      staticStyle: {
        "margin-right": "10px",
        "margin-bottom": "5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleRemoveAccessZone(zone.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(zone.name) + "\n            ")])
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userZonesDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1386:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("From")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "From",
      "format": "MM-dd-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.fromDateChanged($event)
      }
    },
    model: {
      value: (_vm.fromDateCalendar),
      callback: function($$v) {
        _vm.fromDateCalendar = $$v
      },
      expression: "fromDateCalendar"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "demonstration",
    staticStyle: {
      "padding-left": "40px"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "To",
      "format": "MM-dd-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.toDateChanged($event)
      }
    },
    model: {
      value: (_vm.toDateCalendar),
      callback: function($$v) {
        _vm.toDateCalendar = $$v
      },
      expression: "toDateCalendar"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.csvExport()
      }
    }
  }, [_vm._v("Export to\n        CSV")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPressureLine"
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartExTemperatureLine"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterZones
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show Panel Serial Numbers"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.columns.panelSerial),
      callback: function($$v) {
        _vm.$set(_vm.columns, "panelSerial", $$v)
      },
      expression: "columns.panelSerial"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show Billing Due Date"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.columns.billingDueDate),
      callback: function($$v) {
        _vm.$set(_vm.columns, "billingDueDate", $$v)
      },
      expression: "columns.billingDueDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addZoneClick()
      }
    }
  }, [_vm._v("+ Add Zone")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.zones,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Zone Name",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gsd_id",
      "label": "Zone ID",
      "sortable": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boro_name",
      "label": "Boro",
      "sortable": "",
      "width": "150"
    }
  }), _vm._v(" "), (_vm.columns.panelSerial) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "Panel Serial",
      "width": "350"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.billingDueDate) ? _c('el-table-column', {
    attrs: {
      "label": "Next Billing",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billingDue) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1)]
      }
    }], null, false, 2350755131)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.zoneActivate(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Activate")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.zoneEditClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.zoneDialog.title,
      "visible": _vm.zoneDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.zoneDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.zoneDialog.loading),
      expression: "zoneDialog.loading"
    }],
    attrs: {
      "model": _vm.zoneDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone Name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.name),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "name", $$v)
      },
      expression: "zoneDialog.form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zone ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.zoneID),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "zoneID", $$v)
      },
      expression: "zoneDialog.form.zoneID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Boro"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.zoneDialog.form.boro),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "boro", $$v)
      },
      expression: "zoneDialog.form.boro"
    }
  }, _vm._l((_vm.boro_options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Next Billing"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a date"
    },
    model: {
      value: (_vm.zoneDialog.form.nextBillingAt),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "nextBillingAt", $$v)
      },
      expression: "zoneDialog.form.nextBillingAt"
    }
  })], 1), _vm._v(" "), (_vm.zoneDialog.showPanelID) ? _c('el-form-item', {
    attrs: {
      "label": "Panel ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.deviceID),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "deviceID", $$v)
      },
      expression: "zoneDialog.form.deviceID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoneDialogClick()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Setpoint (°F)"
    }
  }, [_c('el-input', {
    on: {
      "focus": _vm.setPointFocus
    },
    model: {
      value: (_vm.form.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "setPoint", $$v)
      },
      expression: "form.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Feedback Sensitivity"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('label', [_vm._v("Feedback Sensitivity (%E"), _c('sup', [_vm._v("-1")]), _vm._v(" / °F)")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.form.feedbackSensitivity),
      callback: function($$v) {
        _vm.$set(_vm.form, "feedbackSensitivity", $$v)
      },
      expression: "form.feedbackSensitivity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.FilterItems
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Column Chooser"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Select",
      "width": "200px"
    },
    on: {
      "change": _vm.columnsSelectionChanged
    },
    model: {
      value: (_vm.columnSelection),
      callback: function($$v) {
        _vm.columnSelection = $$v
      },
      expression: "columnSelection"
    }
  }, _vm._l((_vm.columnOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "label": "Boro"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    on: {
      "change": _vm.FilterItems
    },
    model: {
      value: (_vm.boroSelection),
      callback: function($$v) {
        _vm.boroSelection = $$v
      },
      expression: "boroSelection"
    }
  }, _vm._l((_vm.boroOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.allowManage) ? _c('el-form-item', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToManageZones
    }
  }, [_vm._v("Manage Zones")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.zones,
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.zoneActivateClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "gsd_id",
      "label": "Zone ID",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Zone Name",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "oat",
      "label": "Outdoor Temp"
    }
  }), _vm._v(" "), (_vm.columns.targetPos) ? _c('el-table-column', {
    attrs: {
      "prop": "targetPosition",
      "label": "Target Pos"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currentPosition",
      "label": "Current Pos"
    }
  }), _vm._v(" "), (_vm.columns.temperatureReturn) ? _c('el-table-column', {
    attrs: {
      "prop": "temperatureReturnLine",
      "label": "Return Temperature"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.pressureReturn) ? _c('el-table-column', {
    attrs: {
      "prop": "pressureReturn",
      "label": "Return Pressure"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.softwareVersion) ? _c('el-table-column', {
    attrs: {
      "prop": "softwareVersion",
      "label": "Software Version"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mode",
      "label": "Mode"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mode == 'Manual') ? _c('div', [_vm._v("Valve Set")]) : (scope.row.mode == 'ValveSet') ? _c('div', [_vm._v("Manual")]) : _c('div', [_vm._v(_vm._s(scope.row.mode))])]
      }
    }])
  }), _vm._v(" "), (_vm.columns.compensator) ? _c('el-table-column', {
    attrs: {
      "prop": "compensator",
      "label": "Compensator"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.billingDue) ? _c('el-table-column', {
    attrs: {
      "label": "Next Billing",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billingDue) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1)]
      }
    }], null, false, 2350755131)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vuex 测试")]), _vm._v("\n  Clicked: " + _vm._s(_vm.getCount) + " times\n  "), _c('button', {
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v("-")])])
},staticRenderFns: []}

/***/ }),

/***/ 1391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page5...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('h3', [_vm._v("Zone Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.zoneImage,
      "width": "200",
      "height": "150"
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Upload new Image"
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitFile
    }
  }, [_vm._v("Save Image")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callback"
  }, [_vm._v(_vm._s(_vm.message))])
},staticRenderFns: []}

/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Notifications Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.notifications),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifications", $$v)
      },
      expression: "form.notifications"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateUser
    }
  }, [_vm._v("Update Profile")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Feedback Sensitivity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.feedbackSensitivity),
      callback: function($$v) {
        _vm.$set(_vm.form, "feedbackSensitivity", $$v)
      },
      expression: "form.feedbackSensitivity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sensitivity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.sensitivity),
      callback: function($$v) {
        _vm.$set(_vm.form, "sensitivity", $$v)
      },
      expression: "form.sensitivity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Set Point (°F)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "setPoint", $$v)
      },
      expression: "form.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadband (°F)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.deadband),
      callback: function($$v) {
        _vm.$set(_vm.form, "deadband", $$v)
      },
      expression: "form.deadband"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Valve Adjustment (-% of Target Position)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.valveAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.form, "valveAdjustment", $$v)
      },
      expression: "form.valveAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mild Weather Day"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动区域"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动性质"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "美食/餐厅线上活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "地推活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "线下主题活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "单纯品牌曝光",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特殊资源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.$set(_vm.form, "resource", $$v)
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "线上品牌商赞助"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "线下场地免费"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动形式"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1399:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1400:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Serial Number"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.serialNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "serialNumber", $$v)
      },
      expression: "form.serialNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "IP Address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ipAddress", $$v)
      },
      expression: "form.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Net Mask"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.netMask),
      callback: function($$v) {
        _vm.$set(_vm.form, "netMask", $$v)
      },
      expression: "form.netMask"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mac Address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.macAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "macAddress", $$v)
      },
      expression: "form.macAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Internet Connection"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.internetConnection),
      callback: function($$v) {
        _vm.$set(_vm.form, "internetConnection", $$v)
      },
      expression: "form.internetConnection"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cloud Server Connection"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.cloudServerConnection),
      callback: function($$v) {
        _vm.$set(_vm.form, "cloudServerConnection", $$v)
      },
      expression: "form.cloudServerConnection"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1401:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1402:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone Name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "1"
    },
    model: {
      value: (_vm.form.lowLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lowLimit", $$v)
      },
      expression: "form.lowLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Panel ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.highLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "highLimit", $$v)
      },
      expression: "form.highLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addZone
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1403:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterUsers
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addUserClick()
      }
    }
  }, [_vm._v("+ Add User")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addExistingUserClick()
      }
    }
  }, [_vm._v("+ Add Existing User")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "User Email",
      "min-width": 25,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "Role",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": 25
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userDeleteClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Remove Access\n                        to Zone")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userDeleteDialog.title,
      "visible": _vm.userDeleteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userDeleteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userDeleteDialog.loading),
      expression: "userDeleteDialog.loading"
    }],
    attrs: {
      "model": _vm.userDeleteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userDeleteDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userDeleteDialog.form, "email", $$v)
      },
      expression: "userDeleteDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userDeleteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.userDeleteDialogClick()
      }
    }
  }, [_vm._v("Remove\n                    Access")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addUserDialog.title,
      "visible": _vm.addUserDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.addUserDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.addUserDialog.loading),
      expression: "addUserDialog.loading"
    }],
    attrs: {
      "model": _vm.addUserDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addUserDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "email", $$v)
      },
      expression: "addUserDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUserDialog.form.password),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "password", $$v)
      },
      expression: "addUserDialog.form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "please select user role"
    },
    model: {
      value: (_vm.addUserDialog.form.role),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "role", $$v)
      },
      expression: "addUserDialog.form.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Building Admin",
      "value": "buildingAdmin"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Building Admin Advanced",
      "value": "buildingAdminAdvanced"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addUserDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addUserDialogClick()
      }
    }
  }, [_vm._v("Add User")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addExistingUserDialog.title,
      "visible": _vm.addExistingUserDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.addExistingUserDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.addExistingUserDialog.loading),
      expression: "addExistingUserDialog.loading"
    }],
    attrs: {
      "model": _vm.addExistingUserDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "margin-bottom": "30px",
      "width": "350px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "clearable": "",
      "placeholder": "Please Input"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addExistingUserDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.addExistingUserDialog.form, "email", $$v)
      },
      expression: "addExistingUserDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addExistingUserDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addExistingUserDialogClick()
      }
    }
  }, [_vm._v("Add Access To\n                    Zone")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1404:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.form.zoneId),
      callback: function($$v) {
        _vm.$set(_vm.form, "zoneId", $$v)
      },
      expression: "form.zoneId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Software Version"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.form.softwareVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "softwareVersion", $$v)
      },
      expression: "form.softwareVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bacnet"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.bacnetEnabledCheckboxChange
    },
    model: {
      value: (_vm.form.bacnetEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "bacnetEnabled", $$v)
      },
      expression: "form.bacnetEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1405:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Low Limit (%)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "1"
    },
    model: {
      value: (_vm.form.lowLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lowLimit", $$v)
      },
      expression: "form.lowLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "High Limit (%)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.highLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "highLimit", $$v)
      },
      expression: "form.highLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "Valve Speed (% / Minute)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10"
    },
    model: {
      value: (_vm.form.valveSetSpeed),
      callback: function($$v) {
        _vm.$set(_vm.form, "valveSetSpeed", $$v)
      },
      expression: "form.valveSetSpeed"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Low Pressure Close"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.enabledCheckboxChange
    },
    model: {
      value: (_vm.form.lowPressureClose.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form.lowPressureClose, "enabled", $$v)
      },
      expression: "form.lowPressureClose.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Low Pressure Setpoint (PSI)"
    }
  }, [_c('el-input', {
    on: {
      "focus": _vm.lowPressureCloseSetPointFocus
    },
    model: {
      value: (_vm.form.lowPressureClose.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form.lowPressureClose, "setPoint", $$v)
      },
      expression: "form.lowPressureClose.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1406:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addNoteClick()
      }
    }
  }, [_vm._v("Add Note")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.notesTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    },
    on: {
      "cell-click": _vm.noteEditClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 15,
      "prop": "created",
      "label": "Date Created",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 25,
      "prop": "email",
      "label": "User Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 70,
      "prop": "notes",
      "label": "Note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "Note",
      "visible": _vm.noteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.noteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.noteDialog.loading),
      expression: "noteDialog.loading"
    }],
    attrs: {
      "model": _vm.noteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "New Value",
      "type": "textarea",
      "autosize": ""
    },
    model: {
      value: (_vm.noteDialog.form.note),
      callback: function($$v) {
        _vm.$set(_vm.noteDialog.form, "note", $$v)
      },
      expression: "noteDialog.form.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.noteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.NoteDialogHandler
    }
  }, [_vm._v("Save")]), _vm._v(" "), (!_vm.noteDialog.form.newNote) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.NoteDeleteHandler
    }
  }, [_vm._v("Delete Note")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1407:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "myTable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.apartmentSensorStatus,
      "stripe": ""
    },
    on: {
      "cell-click": _vm.sysStatusClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v("Hall Bridges: " + _vm._s(props.row.hallBridges))])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('el-table-column', {
      key: column.label,
      attrs: {
        "prop": column.prop,
        "label": column.label
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), (_vm.showDatePicker) ? _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("From")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "From",
      "format": "MM-dd-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.fromDateChanged($event)
      }
    },
    model: {
      value: (_vm.fromDateCalendar),
      callback: function($$v) {
        _vm.fromDateCalendar = $$v
      },
      expression: "fromDateCalendar"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "demonstration",
    staticStyle: {
      "padding-left": "40px"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "To",
      "format": "MM-dd-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.toDateChanged($event)
      }
    },
    model: {
      value: (_vm.toDateCalendar),
      callback: function($$v) {
        _vm.toDateCalendar = $$v
      },
      expression: "toDateCalendar"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.csvExport
    }
  }, [_vm._v("Export Data")]), _vm._v(" "), _c('span', {
    staticClass: "demonstration",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("Considered in Average")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.avgConsidered),
      callback: function($$v) {
        _vm.avgConsidered = $$v
      },
      expression: "avgConsidered"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.sysStatusTable,
      "stripe": ""
    },
    on: {
      "cell-click": _vm.sysStatusClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outdoorTemperature",
      "label": "Outside Air Temperature"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "motorCurrentPosition",
      "label": "Motor Current Position"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "motorTargetPosition",
      "label": "Motor Target Position"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "compensator",
      "label": "Compensator"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.dialogVisible = true
            }
          }
        }, [_vm._v(_vm._s(scope.row.compensator))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.sysHeatStatusTable,
      "stripe": ""
    },
    on: {
      "cell-click": _vm.sysOperationClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "mode",
      "label": "Mode"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v(_vm._s(scope.row.mode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "label": "Operation"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "period",
      "label": "Period"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "network",
      "label": "Network"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.temperatureSensorsTable,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sensor",
      "label": "Temperature Sensor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "Current Reading"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "10px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.pressureSensorsTable,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sensor",
      "label": "Pressure Sensor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "Current Reading"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sensor == 'Differential' && scope.row.raw < 0) ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.value))]) : _c('div', [_vm._v(_vm._s(scope.row.value))])]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.heatBalancerTable,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "apartmentAverage",
      "label": "Heat Balancer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueBottom",
      "label": "HB Bottom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueTop",
      "label": "HB Top"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueDifference",
      "label": "HB Difference"
    }
  })], 1)], 1)])], 1), _vm._v(" "), (_vm.apartmentSensorsAvailable) ? _c('el-row', {
    staticStyle: {
      "margin": "top:10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.apartmentSensorMetrics,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "average",
      "label": "Apartments Average"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalSensors",
      "label": "Total Sensor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "onlineSensors",
      "label": "Online"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "networkHealth",
      "label": "Network Health"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "top:10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.outputTable,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Output"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Control"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-text": "Manual",
            "off-text": "Auto",
            "width": 80
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.digitalOutputControlValue($event, scope.row.name)
            }
          },
          model: {
            value: (scope.row.control),
            callback: function($$v) {
              _vm.$set(scope.row, "control", $$v)
            },
            expression: "scope.row.control"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "value",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": !scope.row.control
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.digitalOutputManualValue($event, scope.row.name)
            }
          },
          model: {
            value: (scope.row.value),
            callback: function($$v) {
              _vm.$set(scope.row, "value", $$v)
            },
            expression: "scope.row.value"
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.inputTable,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Input"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "State",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": true
          },
          model: {
            value: (scope.row.value),
            callback: function($$v) {
              _vm.$set(scope.row, "value", $$v)
            },
            expression: "scope.row.value"
          }
        })]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "top:10px"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.editDialog.title,
      "visible": _vm.editDialog.visible,
      "width": "150px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "visible", $event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.editDialog.loading),
      expression: "editDialog.loading"
    }]
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("Current Value : " + _vm._s(_vm.editDialog.currentValue))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "New Value",
      "type": "number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editDialogHandler($event)
      }
    },
    model: {
      value: (_vm.editDialog.value),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "value", $$v)
      },
      expression: "editDialog.value"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editDialogHandler
    }
  }, [_vm._v("Save to Panel")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Mode",
      "visible": _vm.modeDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.modeDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.modeDialog.loading),
      expression: "modeDialog.loading"
    }],
    attrs: {
      "model": _vm.modeDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    on: {
      "change": _vm.modeDialogChangeValue
    },
    model: {
      value: (_vm.modeDialog.form.mode),
      callback: function($$v) {
        _vm.$set(_vm.modeDialog.form, "mode", $$v)
      },
      expression: "modeDialog.form.mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ValveSet"
    }
  }, [_vm._v("Manual")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Manual"
    }
  }, [_vm._v("Valve Set")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Program Mode"
    }
  }, [_vm._v("Program Mode")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Pause"
    }
  }, [_vm._v("Pause")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Off"
    }
  }, [_vm._v("Off")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.modeDialog.valveSetOptionsVisible),
      expression: "modeDialog.valveSetOptionsVisible"
    }]
  }, [_c('el-radio-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modeDialog.valveSetOptionsVisible),
      expression: "modeDialog.valveSetOptionsVisible"
    }],
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.modeDialog.form.valveSet),
      callback: function($$v) {
        _vm.$set(_vm.modeDialog.form, "valveSet", $$v)
      },
      expression: "modeDialog.form.valveSet"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Closed"
    }
  }, [_vm._v("Closed")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Open"
    }
  }, [_vm._v("Open")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', [_c('div', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.modeDialog.manualSetOptionsVisible),
      expression: "modeDialog.manualSetOptionsVisible"
    }]
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("Current Value : " + _vm._s(_vm.modeDialog.form.currentManualPosition))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "New Value",
      "type": "number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.modeDialogHandler($event)
      }
    },
    model: {
      value: (_vm.modeDialog.form.manualPosition),
      callback: function($$v) {
        _vm.$set(_vm.modeDialog.form, "manualPosition", $$v)
      },
      expression: "modeDialog.form.manualPosition"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modeDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modeDialogHandler
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "280px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mild Weather Day (°F)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": _vm.valueChanged
    },
    model: {
      value: (_vm.form.mildWeatherDay),
      callback: function($$v) {
        _vm.$set(_vm.form, "mildWeatherDay", $$v)
      },
      expression: "form.mildWeatherDay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mild Weather Night (°F)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": _vm.valueChanged
    },
    model: {
      value: (_vm.form.mildWeatherNight),
      callback: function($$v) {
        _vm.$set(_vm.form, "mildWeatherNight", $$v)
      },
      expression: "form.mildWeatherNight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "Valve Feedback Sensitivity (T5 - %/°F)"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('label', [_vm._v("Feedback Sensitivity (T5 %E"), _c('sup', [_vm._v("-1")]), _vm._v(" / °F)")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": _vm.valueChanged
    },
    model: {
      value: (_vm.form.valveFeedbackSensitivity),
      callback: function($$v) {
        _vm.$set(_vm.form, "valveFeedbackSensitivity", $$v)
      },
      expression: "form.valveFeedbackSensitivity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "Exponential Curve"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": _vm.valueChanged
    },
    model: {
      value: (_vm.form.exponentialCurve),
      callback: function($$v) {
        _vm.$set(_vm.form, "exponentialCurve", $$v)
      },
      expression: "form.exponentialCurve"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Exponential Sensitivity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": _vm.valueChanged
    },
    model: {
      value: (_vm.form.exponentialSensitivity),
      callback: function($$v) {
        _vm.$set(_vm.form, "exponentialSensitivity", $$v)
      },
      expression: "form.exponentialSensitivity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Integral Period (Minutes)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.integralPeriod),
      callback: function($$v) {
        _vm.$set(_vm.form, "integralPeriod", $$v)
      },
      expression: "form.integralPeriod"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Integral Setpoint (°F Loss in Period)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.integralSetpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "integralSetpoint", $$v)
      },
      expression: "form.integralSetpoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "float": "right",
      "margin-top": "-80px"
    },
    on: {
      "change": _vm.dayNightSelectorChange
    },
    model: {
      value: (_vm.dayNightSelector),
      callback: function($$v) {
        _vm.dayNightSelector = $$v
      },
      expression: "dayNightSelector"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Day"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Night"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "-50px"
    },
    attrs: {
      "id": "chartLine"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page6...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1411:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addAlarmClick()
      }
    }
  }, [_vm._v("Add Alarm")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.alarmsTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    },
    on: {
      "cell-click": _vm.alarmEditClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "name",
      "label": "Name",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 200,
      "prop": "alarm_type_name",
      "label": "Alarm Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Enabled",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.enabled == 0) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Disabled")])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Enabled")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Current State",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 0) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Reset")])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Triggered")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 70,
      "prop": "threshold",
      "label": "Threshold"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 70,
      "prop": "hysterisis",
      "label": "Hysterisis"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "firedAtFormatted",
      "label": "Last Triggered"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Zone Alarm Log")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.alarmLogTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "name",
      "label": "Alarm Name",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "alarm_type_name",
      "label": "Alarm Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "triggeredAtFormatted",
      "label": "Last Triggered"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "Alarm",
      "visible": _vm.alarmDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.alarmDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.alarmDialog.loading),
      expression: "alarmDialog.loading"
    }],
    attrs: {
      "model": _vm.alarmDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.alarmDialog.form.newAlarm) ? _c('el-form-item', {
    attrs: {
      "label": "Alarm Type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.alarmTypeChange()
      }
    },
    model: {
      value: (_vm.alarmDialog.form.alarmTypeId),
      callback: function($$v) {
        _vm.$set(_vm.alarmDialog.form, "alarmTypeId", $$v)
      },
      expression: "alarmDialog.form.alarmTypeId"
    }
  }, _vm._l((_vm.alarmTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.alarmDialog.form.name),
      callback: function($$v) {
        _vm.$set(_vm.alarmDialog.form, "name", $$v)
      },
      expression: "alarmDialog.form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.alarmDialog.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.alarmDialog.form, "enabled", $$v)
      },
      expression: "alarmDialog.form.enabled"
    }
  })], 1), _vm._v(" "), (_vm.alarmDialog.threshold.visible) ? _c('el-form-item', {
    attrs: {
      "label": _vm.alarmDialog.threshold.label
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.alarmDialog.form.threshold),
      callback: function($$v) {
        _vm.$set(_vm.alarmDialog.form, "threshold", $$v)
      },
      expression: "alarmDialog.form.threshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.alarmDialog.hysterisis.visible) ? _c('el-form-item', {
    attrs: {
      "label": _vm.alarmDialog.hysterisis.label
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.alarmDialog.form.hysterisis),
      callback: function($$v) {
        _vm.$set(_vm.alarmDialog.form, "hysterisis", $$v)
      },
      expression: "alarmDialog.form.hysterisis"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.alarmDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.AlarmDialogHandler
    }
  }, [_vm._v("Save")]), _vm._v(" "), (!_vm.alarmDialog.form.newAlarm) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.AlarmDeleteHandler
    }
  }, [_vm._v("Delete Alarm")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1412:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1413:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterZones
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.logsTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "timeFormatted",
      "label": "Time",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "category_type_name",
      "label": "Category",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "entity_type_name",
      "label": "Entity",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "log_type_name",
      "label": "Log Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "type_name",
      "label": "Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "old_value",
      "label": "Old Value",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "new_value",
      "label": "New Value",
      "sortable": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Set Point (inHg)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "setPoint", $$v)
      },
      expression: "form.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadband (inHg)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.deadband),
      callback: function($$v) {
        _vm.$set(_vm.form, "deadband", $$v)
      },
      expression: "form.deadband"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "80%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "0px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._l((_vm.form.targetPosition), function(item, index) {
    return _c('el-form-item', [_c('table', [_c('tr', [_c('td', [_vm._v("Position @ " + _vm._s(index + -10) + "°F")]), _vm._v(" "), _c('td', [_c('el-input', {
      model: {
        value: (_vm.form.targetPosition[index]),
        callback: function($$v) {
          _vm.$set(_vm.form.targetPosition, index, $$v)
        },
        expression: "form.targetPosition[index]"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1580:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1581:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getApartmentSensors: function getApartmentSensors(zoneID) {
    return _axios2.default.post("/getApartmentsV2", { zoneID: zoneID }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getApartmentLettersInZone: function getApartmentLettersInZone(zoneID) {
    return _axios2.default.post("/getApartmentLettersInZone", { zoneID: zoneID }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getApartmentsMetrics: function getApartmentsMetrics(zoneID) {
    return _axios2.default.post("/getApartmentsMetrics", { zoneID: zoneID }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getApartmentData: function getApartmentData(zoneID, floor, apartment) {
    return _axios2.default.post("/getApartmentData", {
      zoneID: zoneID,
      floor: floor,
      apartment: apartment
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getApartmentHistory: function getApartmentHistory(zoneID, floor, apartment, from, to) {
    return _axios2.default.post("/getApartmentHistory", {
      zoneID: zoneID,
      floor: floor,
      apartment: apartment,
      from: from,
      to: to
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  }
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = "yyyy-MM-dd";
function padding(s, len) {
  var len = len - (s + "").length;
  for (var i = 0; i < len; i++) {
    s = "0" + s;
  }
  return s;
}

exports.default = {
  getQueryStringByName: function getQueryStringByName(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    var context = "";
    if (r != null) context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
  },
  printTemperature: function printTemperature(result) {
    if (result == -500) return "Error";else return result + "°F";
  },
  printPressure: function printPressure(result) {
    if (result == -500) return "Error";

    if (result >= 0) return result.toFixed(1) + " PSI";else return (result * -1 * 2.03602).toFixed(1) + " inHg";
  },
  formatDate: {
    format: function format(date, pattern) {
      pattern = pattern || DEFAULT_PATTERN;
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case "y":
            return padding(date.getFullYear(), $0.length);
          case "M":
            return padding(date.getMonth() + 1, $0.length);
          case "d":
            return padding(date.getDate(), $0.length);
          case "w":
            return date.getDay() + 1;
          case "h":
            return padding(date.getHours(), $0.length);
          case "m":
            return padding(date.getMinutes(), $0.length);
          case "s":
            return padding(date.getSeconds(), $0.length);
        }
      });
    },
    parse: function parse(dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP);
      var matchs2 = dateString.match(/(\d)+/g);
      if (matchs1.length == matchs2.length) {
        var _date = new Date(1970, 0, 1);
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i]);
          var sign = matchs1[i];
          switch (sign.charAt(0)) {
            case "y":
              _date.setFullYear(_int);
              break;
            case "M":
              _date.setMonth(_int - 1);
              break;
            case "d":
              _date.setDate(_int);
              break;
            case "h":
              _date.setHours(_int);
              break;
            case "m":
              _date.setMinutes(_int);
              break;
            case "s":
              _date.setSeconds(_int);
              break;
          }
        }
        return _date;
      }
      return null;
    }
  }
};

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(128);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(216);

var _stringify2 = _interopRequireDefault(_stringify);

var _auth0Js = __webpack_require__(568);

var _auth0Js2 = _interopRequireDefault(_auth0Js);

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(537);

var appAuthRedirectURI =  true ? config.build.appAuthRedirectURI : config.dev.appAuthRedirectURI;

var webAuth = new _auth0Js2.default.WebAuth({
  domain: "varivac.auth0.com",
  clientID: "jh64aDSRzSQjo3rEwC0CudAp0H32E4LP",
  redirectUri: appAuthRedirectURI,
  audience: "https://varivac.auth0.com/api/v2/",
  responseType: "token id_token",
  scope: "openid profile email"
});

var auth = new _vue2.default({
  computed: {
    token: {
      get: function get() {
        return localStorage.getItem("id_token");
      },
      set: function set(id_token) {
        localStorage.setItem("id_token", id_token);
      }
    },
    accessToken: {
      get: function get() {
        return localStorage.getItem("access_token");
      },
      set: function set(accessToken) {
        localStorage.setItem("access_token", accessToken);
      }
    },
    expiresAt: {
      get: function get() {
        return localStorage.getItem("expires_at");
      },
      set: function set(expiresIn) {
        var expiresAt = (0, _stringify2.default)(expiresIn * 1000 + new Date().getTime());
        localStorage.setItem("expires_at", expiresAt);
      }
    },
    user: {
      get: function get() {
        return JSON.parse(localStorage.getItem("user"));
      },
      set: function set(user) {
        localStorage.setItem("user", (0, _stringify2.default)(user));
      }
    }
  },
  methods: {
    login: function login() {
      webAuth.authorize({
        audience: "https://variablevac.com/"
      });
    },
    logout: function logout() {
      this.$session.destroy();
      webAuth.logout({
        clientID: webAuth.baseOptions.clientID,
        returnTo: "https://www.variablevac.com/",
        federated: true
      });
      localStorage.removeItem("access_token");
      localStorage.removeItem("id_token");
      localStorage.removeItem("expires_at");
      localStorage.removeItem("user");
    },
    isAuthenticated: function isAuthenticated() {
      return new Date().getTime() < this.expiresAt;
    },
    handleAuthentication: function handleAuthentication() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        webAuth.parseHash(function (err, authResult) {
          if (authResult && authResult.accessToken && authResult.idToken) {
            _this.expiresAt = authResult.expiresIn;
            _this.accessToken = authResult.accessToken;
            _this.token = authResult.idToken;
            _this.user = authResult.idTokenPayload;
            resolve();
          } else if (err) {
            _this.logout();
            reject(err);
          }
        });
      });
    }
  }
});

exports.default = {
  install: function install(Vue) {
    Vue.prototype.$auth = auth;
  }
};

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getIO: function getIO(device) {
    return _axios2.default.post("/getIO", { deviceID: device }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getApartmentAverage: function getApartmentAverage(device) {
    return _axios2.default.post("/getApartmentAverage", { deviceID: device }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getSettings: function getSettings(device) {
    return _axios2.default.post("/getSettings", { deviceID: device }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getOperationStatus: function getOperationStatus(device) {
    return _axios2.default.post("/getOperationStatus", { deviceID: device }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZoneTemperatureHistory: function getZoneTemperatureHistory(zoneID, from, to) {
    return _axios2.default.post("/getZoneTemperatureHistory", {
      zoneID: zoneID,
      from: from,
      to: to
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZoneMode: function getZoneMode(zoneID, time) {
    return _axios2.default.post("/getZoneMode", {
      zoneID: zoneID,
      time: time
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZoneCompensatorSetting: function getZoneCompensatorSetting(zoneID, time) {
    return _axios2.default.post("/getZoneCompensatorSetting", {
      zoneID: zoneID,
      time: time
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZoneMonitorCurrentPositionHistory: function getZoneMonitorCurrentPositionHistory(zoneID, from, to) {
    return _axios2.default.post("/getZoneMotorCurrentPositionHistory", {
      zoneID: zoneID,
      from: from,
      to: to
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZonePressureBoilerHistory: function getZonePressureBoilerHistory(zoneID, from, to) {
    return _axios2.default.post("/getZonePressureBoilerHistory", {
      zoneID: zoneID,
      from: from,
      to: to
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  },
  getZoneMonitorTargetPositionHistory: function getZoneMonitorTargetPositionHistory(zoneID, from, to) {
    return _axios2.default.post("/getZoneMotorTargetPositionHistory", {
      zoneID: zoneID,
      from: from,
      to: to
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
};

exports.default = {
  changeSetting: function changeSetting(device, settingKey, newValue) {
    return _axios2.default.post("/changeSetting", {
      deviceID: device,
      setting: settingKey,
      value: newValue
    }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
    });
  }
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(629);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _freeze2.default)({
  MOTOR_MANUAL_POSITION: { min: 0, max: 100 },

  MILD_WEATHER_DAY: { min: 50.0, max: 120.0 },
  MILD_WEATHER_NIGHT: { min: 50.0, max: 120.0 },
  VALVE_FEEDBACK_SENSITIVITY: { min: 1, max: 100 },
  EXPONENTIAL_SENSITIVITY: { min: 0, max: 100 },
  EXPONENTIAL_CURVE: { min: 0, max: 100 },

  VALVE_SET_SPEED: { min: 1, max: 10 },

  HEAT_BALANCER_FEEDBACK_SENSITIVITY: { min: 1, max: 10 },

  RAMP_UP_SPEED: { min: 1, max: 10 },
  RAMP_DOWN_SPEED: { min: 1, max: 10 },
  HEATUP_ADJUSTMENT: { min: -100, max: 100 },
  MIDDAY_ADJUSTMENT: { min: -100, max: 100 },
  NIGH_ADJUSTMENT: { min: -100, max: 100 },

  COMPENSATOR: { min: -50, max: 50 },
  COMPENSATOR_SENSITIVITY: { min: 1, max: 50 },

  RETURN_LINE_SETPOINT: { min: 50.0, max: 180 },
  RETURN_LINE_DEADBAND: { min: 1, max: 10 },
  RETURN_LINE_VALVE_ADJUSTMENT: { min: -90, max: -1 },

  DIFFERENTIAL_SETPOINT: { min: 0, max: 40 },
  DIFFERENTIAL_DEADBAND: { min: 0.1, max: 20 },

  TEMPERATURE_SENSORS_CALIBRATION_ADJUSTMENT: { min: -100, max: 100 },
  TEMPERATURE_SENSORS_RANGE_HIGH: { min: 0, max: 1000 },
  TEMPERATURE_SENSORS_RANGE_LOW: { min: -1000, max: 1000 },

  PRESSURE_SENSORS_CALIBRATION_ADJUSTMENT: { min: -100, max: 100 },
  PRESSURE_SENSORS_RANGE_HIGH: { min: 0, max: 1000 },
  PRESSURE_SENSORS_RANGE_LOW: { min: -1000, max: 1000 }
});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(1345);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1351);

var _Home2 = _interopRequireDefault(_Home);

var _Zones = __webpack_require__(1360);

var _Zones2 = _interopRequireDefault(_Zones);

var _ZonesDashboard = __webpack_require__(1361);

var _ZonesDashboard2 = _interopRequireDefault(_ZonesDashboard);

var _ZoneInfo = __webpack_require__(1357);

var _ZoneInfo2 = _interopRequireDefault(_ZoneInfo);

var _Notes = __webpack_require__(1353);

var _Notes2 = _interopRequireDefault(_Notes);

var _ZoneAlarms = __webpack_require__(1356);

var _ZoneAlarms2 = _interopRequireDefault(_ZoneAlarms);

var _ZoneLogs = __webpack_require__(1358);

var _ZoneLogs2 = _interopRequireDefault(_ZoneLogs);

var _Users = __webpack_require__(1355);

var _Users2 = _interopRequireDefault(_Users);

var _ZoneUsers = __webpack_require__(1359);

var _ZoneUsers2 = _interopRequireDefault(_ZoneUsers);

var _AddZone = __webpack_require__(1346);

var _AddZone2 = _interopRequireDefault(_AddZone);

var _Profile = __webpack_require__(1354);

var _Profile2 = _interopRequireDefault(_Profile);

var _ApartmentSensors = __webpack_require__(1347);

var _ApartmentSensors2 = _interopRequireDefault(_ApartmentSensors);

var _Archive = __webpack_require__(1348);

var _Archive2 = _interopRequireDefault(_Archive);

var _Main = __webpack_require__(1352);

var _Main2 = _interopRequireDefault(_Main);

var _Form = __webpack_require__(1363);

var _Form2 = _interopRequireDefault(_Form);

var _Heat = __webpack_require__(1371);

var _Heat2 = _interopRequireDefault(_Heat);

var _Motor = __webpack_require__(1373);

var _Motor2 = _interopRequireDefault(_Motor);

var _HeatBalancer = __webpack_require__(1372);

var _HeatBalancer2 = _interopRequireDefault(_HeatBalancer);

var _ApartmentAverage = __webpack_require__(1367);

var _ApartmentAverage2 = _interopRequireDefault(_ApartmentAverage);

var _AutoHeatAdjust = __webpack_require__(1368);

var _AutoHeatAdjust2 = _interopRequireDefault(_AutoHeatAdjust);

var _Compensator = __webpack_require__(1369);

var _Compensator2 = _interopRequireDefault(_Compensator);

var _ReturnLine = __webpack_require__(1377);

var _ReturnLine2 = _interopRequireDefault(_ReturnLine);

var _Differential = __webpack_require__(1370);

var _Differential2 = _interopRequireDefault(_Differential);

var _ProgramMode = __webpack_require__(1376);

var _ProgramMode2 = _interopRequireDefault(_ProgramMode);

var _TemperatureSensors = __webpack_require__(1379);

var _TemperatureSensors2 = _interopRequireDefault(_TemperatureSensors);

var _PressureSensors = __webpack_require__(1375);

var _PressureSensors2 = _interopRequireDefault(_PressureSensors);

var _Network = __webpack_require__(1374);

var _Network2 = _interopRequireDefault(_Network);

var _System = __webpack_require__(1378);

var _System2 = _interopRequireDefault(_System);

var _Callback = __webpack_require__(1349);

var _Callback2 = _interopRequireDefault(_Callback);

var _Page = __webpack_require__(1364);

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__(1365);

var _Page4 = _interopRequireDefault(_Page3);

var _Page5 = __webpack_require__(1366);

var _Page6 = _interopRequireDefault(_Page5);

var _echarts = __webpack_require__(1362);

var _echarts2 = _interopRequireDefault(_echarts);

var _Dashboard = __webpack_require__(1350);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: "/",
  redirect: "/Dashboard",
  hidden: true
}, {
  path: "/callback",
  component: _Callback2.default,
  name: "Callback",
  hidden: true
}, {
  path: "/404",
  component: _2.default,
  name: "",
  hidden: true
}, {
  path: "/",
  component: _Home2.default,
  name: "Dash",
  iconCls: "fa fa-home",
  leaf: true,
  children: [{ path: "/Dashboard", component: _Dashboard2.default, name: "Dashboard" }]
}, {
  path: "/",
  component: _Home2.default,
  name: "Settings",
  iconCls: "fa fa-cogs",
  children: [{ path: "/HeatSettings", component: _Heat2.default, name: "Heat" }, { path: "/MotorSettings", component: _Motor2.default, name: "Valve" }, { path: "/HeatBalancerSettings", component: _HeatBalancer2.default, name: "Heat Balancer" }, { path: "/AutoHeatSettings", component: _AutoHeatAdjust2.default, name: "Auto Heat" }, { path: "/CompensatorSettings", component: _Compensator2.default, name: "Compensator" }, { path: "/ReturnLineSettings", component: _ReturnLine2.default, name: "Return Line" }, { path: "/DifferentialSettings", component: _Differential2.default, name: "Differential" }, { path: "/TemperatureSensorSettings", component: _TemperatureSensors2.default, name: "Temperature Sensors", hidden: false }, { path: "/PressureSensorSettings", component: _PressureSensors2.default, name: "Pressure Sensors", hidden: false }, { path: "/ProgramMode", component: _ProgramMode2.default, name: "Program mode", hidden: false }, { path: "/NetworkSettings", component: _Network2.default, name: "Network", hidden: true }, { path: "/SystemSettings", component: _System2.default, name: "System", hidden: false }, { path: "/ApartmentAverageSettings", component: _ApartmentAverage2.default, name: "Apartment Average" }]
}, {
  path: "/",
  component: _Home2.default,
  name: "Dash",
  iconCls: "fa fa-history",
  leaf: true,
  children: [{ path: "/ArchiveLocal", component: _Archive2.default, name: "Zone History" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-info",
  name: "Zone Notes",
  leaf: true,
  children: [{ path: "/Notes", component: _Notes2.default, name: "Zone Notes" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-info",
  name: "Zone Alarms",
  leaf: true,
  children: [{ path: "/ZoneAlarms", component: _ZoneAlarms2.default, name: "Zone Alarms" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-info",
  name: "Zone Logs",
  leaf: true,
  children: [{ path: "/ZoneLogs", component: _ZoneLogs2.default, name: "Zone Logs" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-info",
  name: "ZoneInfo",
  leaf: true,
  children: [{ path: "/ZoneInfo", component: _ZoneInfo2.default, name: "Zone Info" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-info",
  name: "ZoneUsers",
  leaf: true,
  children: [{ path: "/ZoneUsers", component: _ZoneUsers2.default, name: "Zone Users" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-history",
  name: "Apartment History",
  leaf: true,
  children: [{ path: "/ApartmentSensors", component: _ApartmentSensors2.default, name: "Apartments History" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-building",
  name: "ZonesDashboard",
  leaf: true,
  children: [{ path: "/ZonesDashboard", component: _ZonesDashboard2.default, name: "My Zones" }]
}, {
  path: "/",
  component: _Home2.default,
  iconCls: "fa fa-building",
  name: "UsersManager",
  leaf: true,
  children: [{ path: "/Users", component: _Users2.default, name: "User Administration" }]
}, {
  path: "/",
  component: _Home2.default,
  name: "Zones",
  leaf: true,
  hidden: true,
  children: [{ path: "/Zones", component: _Zones2.default, name: "Zones" }]
}, {
  path: "/",
  component: _Home2.default,
  name: "Add Zone",
  leaf: true,
  hidden: true,
  children: [{ path: "/AddZone", component: _AddZone2.default, name: "AddZone" }]
}, {
  path: "/",
  component: _Home2.default,
  name: "Profile",
  leaf: true,
  hidden: true,
  children: [{ path: "/Profile", component: _Profile2.default, name: "Profile" }]
}];

exports.default = routes;

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(214);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(623);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(624);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1196)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1412),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(1538)
var prodEnv = __webpack_require__(318)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(204)

module.exports = {
  build: {
    env: __webpack_require__(318),
    index: path.resolve(__dirname, "../dist/index.html"),
    assetsRoot: path.resolve(__dirname, "../dist"),
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    appAuthRedirectURI: "https://www.variablevac.com/callback",
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(536),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    appAuthRedirectURI: "https://www.variablevac.com/callback",
    // appAuthRedirectURI: "http://localhost:8080/callback",
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        zoneName: '',
        panelID: ''
      },
      user: this.$session.get('User')
    };
  },
  mounted: function mounted() {},

  methods: {
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      this.loading = true;
      _axios2.default.all([SettingsService.changeSetting(this.user.activeZone, 'Settings.Motor.Limit.Low', this.form.lowLimit)]).then(_axios2.default.spread(function (lowLimitResponse, highLimitResponse, valveSetSpeedResponse) {
        _this.loading = false;
        if (lowLimitResponse.data.result != "success" || highLimitResponse.data.result != "success" || valveSetSpeedResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: 'Motor Settings',
            message: 'Error trying to save data to panel',
            type: 'error'
          });
        } else {
          _this.$notify({
            title: 'Motor',
            message: 'Settings Saved to Panel',
            type: 'info'
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: 'Motor Settings',
          message: 'Error trying to save data to panel',
          type: 'error'
        });
      });
    }
  }
};

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _values = __webpack_require__(327);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(326);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(218);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _apartments = __webpack_require__(162);

var _apartments2 = _interopRequireDefault(_apartments);

var _exportToCsv = __webpack_require__(442);

var _exportToCsv2 = _interopRequireDefault(_exportToCsv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      avgConsidered: false,
      showDatePicker: false,
      polling: null,
      apartmentSensorStatus: [],
      chartColumn: null,
      chartBar: null,
      chartLine: null,
      chartPie: null,
      user: this.$session.get("User"),
      fortest: 0,
      apartmentHistoryData: [],
      apartmentHistoryAxis: [],

      toDateCalendar: new Date().toISOString(),
      fromDateCalendar: new Date().toISOString(),
      toDate: new Date(),
      fromDate: new Date(),
      floor: null,
      apartment: null,
      csvOptions: {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Varivac Data Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      },
      columns: [{
        prop: "floor",
        label: "Floor"
      }]
    };
  },


  methods: {
    csvExport: function csvExport() {
      var arrData = this.apartmentHistoryData;
      var csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [(0, _keys2.default)(arrData[0]).join(",")].concat((0, _toConsumableArray3.default)(arrData.map(function (item) {
        return (0, _values2.default)(item).join(",");
      }))).join("\n").replace(/(^\[)|(\]$)/gm, "");

      var data = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    fromDateChanged: function fromDateChanged(event) {
      this.fromDate = new Date(event);
      this.getApartmentHistory(this.floor, this.apartment);
    },
    toDateChanged: function toDateChanged(event) {
      this.toDate = new Date(event);
      this.getApartmentHistory(this.floor, this.apartment);
    },
    drawLineChart: function drawLineChart(floor, apartment) {
      this.showDatePicker = true;
      var apartmentName = floor + "-" + apartment;
      this.chartLine = _echarts2.default.init(document.getElementById("chartLine"));
      this.chartLine.setOption({
        title: {
          text: "Apartment " + apartmentName
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["Temperature °F  " + apartmentName]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          min: 60,
          max: 85,
          axisLabel: { formatter: "{value} °F" }
        },
        series: [{
          name: "Temperature °F  " + apartmentName,
          type: "line",
          stack: "总量",
          showSymbol: false,
          data: this.apartmentHistoryData
        }]
      });
    },
    getApartmentHistory: function getApartmentHistory(floor, apartment) {
      var _this = this;

      var toDate = this.toDate;
      toDate.setUTCHours(23);
      toDate.setUTCMinutes(59);
      var toDateFormatted = toDate.toISOString();
      var fromDateFormatted = this.fromDate.toISOString();
      _axios2.default.all([_apartments2.default.getApartmentHistory(this.user.activeZone, floor, apartment, fromDateFormatted, toDateFormatted)]).then(_axios2.default.spread(function (ApartmentsResponse) {
        _this.apartmentHistoryData = [];
        _this.apartmentHistoryAxis = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(ApartmentsResponse.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _this.apartmentHistoryData.push([item.time, item.temperature]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.drawLineChart(floor, apartment);
      }));
    },
    getApartmentData: function getApartmentData(floor, apartment) {
      var _this2 = this;

      _axios2.default.all([_apartments2.default.getApartmentData(this.user.activeZone, floor, apartment)]).then(_axios2.default.spread(function (ApartmentsResponse) {
        console.log(ApartmentsResponse.data);
        _this2.avgConsidered = ApartmentsResponse.data.isConsideredInAvg == 1;
      }));
    },
    sysStatusClick: function sysStatusClick(row, column, cell, event) {
      console.log(row.floor);
      console.log(column.property);
      if (column.property != "Floor") {
        this.floor = row.floor;
        this.apartment = column.property;
        this.getApartmentHistory(this.floor, this.apartment);
        this.getApartmentData(this.floor, this.apartment);
      }
    },
    toFahrenheit: function toFahrenheit(degC) {
      console.log(degC);
      if (typeof degC === "undefined") {
        return "";
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F";
      }
    },
    compare: function compare(a, b) {
      return a.floor < b.floor ? 1 : -1;
    },
    isInArray: function isInArray(floor) {
      for (var i = 0; i < this.apartmentSensorStatus.length; i++) {
        if (this.apartmentSensorStatus[i].floor == floor) {
          return i;
        }
      }
      return -1;
    },
    createColumns: function createColumns() {
      var _this3 = this;

      _axios2.default.all([_apartments2.default.getApartmentLettersInZone(this.user.activeZone)]).then(_axios2.default.spread(function (ApartmentLettersResponse) {
        if (typeof ApartmentLettersResponse.data.error !== "undefined") {} else {
          ApartmentLettersResponse.data.forEach(function (element) {
            _this3.columns.push({
              prop: element.apartment,
              label: element.apartment
            });
          });
        }
      }));
    },
    getData: function getData() {
      var _this4 = this;

      _axios2.default.all([_apartments2.default.getApartmentSensors(this.user.activeZone)]).then(_axios2.default.spread(function (ApartmentsResponse) {
        if (typeof ApartmentsResponse.data.error !== "undefined") {} else {
          _this4.apartmentSensorStatus.forEach(function (element) {
            element.hallBridges = "";
          });

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(ApartmentsResponse.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var sensor = _step2.value;

              var checkIfInArray = _this4.isInArray(sensor.floor);
              if (checkIfInArray == -1) {
                var newFloor = {
                  floor: sensor.floor,
                  hallBridges: ""
                };
                if (sensor.isHallBridge == 1) {
                  newFloor.hallBridges += sensor.sensor_id + " " + sensor.floor + sensor.apartment + ":" + (sensor.online ? "Online" : "Offline") + "<br>";
                } else {
                  if (!sensor.online) {
                    newFloor[sensor.apartment] = "Offline";
                  } else {
                    newFloor[sensor.apartment] = _this4.toFahrenheit(sensor.currentTemperature);
                  }
                }
                _this4.apartmentSensorStatus.push(newFloor);
              } else {
                if (sensor.isHallBridge == 1) {
                  _this4.apartmentSensorStatus[checkIfInArray].hallBridges += "[" + sensor.sensor_id + " " + sensor.floor + sensor.apartment + ":" + (sensor.online ? "Online" : "Offline") + "] ";
                } else {
                  if (!sensor.online) {
                    _this4.apartmentSensorStatus[checkIfInArray][sensor.apartment] = "Offline";
                  } else {
                    _this4.apartmentSensorStatus[checkIfInArray][sensor.apartment] = _this4.toFahrenheit(sensor.currentTemperature);
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this4.apartmentSensorStatus.sort(_this4.compare);
          _this4.$refs.myTable.doLayout();
          console.log(_this4.apartmentSensorStatus);
        }
      }));
    }
  },

  mounted: function mounted() {
    var yesterday = new Date();
    yesterday.setDate(new Date().getDate() - 8);
    this.fromDate = yesterday;
    this.fromDateCalendar = yesterday.toISOString();

    this.getData();
    this.createColumns();
    this.polling = setInterval(this.getData, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  },

  updated: function updated() {}
};

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(635);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(633);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = __webpack_require__(327);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(326);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(218);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _exportToCsv = __webpack_require__(442);

var _exportToCsv2 = _interopRequireDefault(_exportToCsv);

var _dateformat = __webpack_require__(183);

var _dateformat2 = _interopRequireDefault(_dateformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      mode: "NA",
      compensatorValue: "NA",
      showDatePicker: false,
      polling: null,
      apartmentSensorStatus: [],
      chartColumn: null,
      chartBar: null,
      chartLine: null,
      chartPressureLine: null,
      chartExTemperatureLine: null,
      chartPie: null,
      user: this.$session.get("User"),
      fortest: 0,

      zoneTemperatureHistoryData: [],
      zoneReturnTemperatureHistoryData: [],
      zoneDomesticWaterTemperatureHistoryData: [],
      zoneAuxHistoryData: [],

      zoneMotorCurrentPositionHistoryData: [],
      zoneMotorTargetPositionHistoryData: [],

      zonePressureBoilerHistoryData: [],
      zonePressureSupplyHistoryData: [],
      zonePressureReturnHistoryData: [],

      csvArray: [],

      toDateCalendar: new Date().toISOString(),
      fromDateCalendar: new Date().toISOString(),
      toDate: new Date(),
      fromDate: new Date(),
      floor: null,
      apartment: null,
      csvOptions: {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Varivac Data Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      }
    };
  },


  methods: {
    csvExport: function csvExport() {
      var arrData = this.csvArray;
      var csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [(0, _keys2.default)(arrData[0]).join(",")].concat((0, _toConsumableArray3.default)(arrData.map(function (item) {
        return (0, _values2.default)(item).join(",");
      }))).join("\n").replace(/(^\[)|(\]$)/gm, "");

      var data = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    fromDateChanged: function fromDateChanged(event) {
      this.fromDate = new Date(event);
      this.getZoneHistory();
    },
    toDateChanged: function toDateChanged(event) {
      this.toDate = new Date(event);
      this.getZoneHistory();
    },
    getZoneModeText: function getZoneModeText(val) {
      switch (val) {
        case 0:
          return "Auto";
        case 1:
          return "Valve Set";
        case 2:
          return "Manual";
        case 3:
          return "Program Mode";
        case 4:
          return "Pause";
        case 5:
          return "Off";
        case 6:
          return "Calibrate";
      }
      return "";
    },
    drawLineChart: function drawLineChart(zoneID) {
      var _this = this;

      this.showDatePicker = true;
      this.chartLine = _echarts2.default.init(document.getElementById("chartLine"));
      this.chartLine.setOption({
        title: {
          text: "OAT and Valve Position"
        },

        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: function formatter(params) {
            _this.getZoneMode(params[0].value[0]);
            _this.getZoneCompensatorSetting(params[0].value[0]);

            var now = new Date(params[0].value[0]);
            var dateFormatted = (0, _dateformat2.default)(now, "m-dd-yyyy, h:MM TT");
            try {
              var result = "\n                    Time: " + dateFormatted + "</br>\n                    OAT: " + params[0].value[1].toFixed(1) + " \xB0F</br>\n                    Valve Position: " + params[1].value[1].toFixed(1) + " %</br>\n                    Valve Target: " + params[2].value[1].toFixed(1) + " %</br>\n                    Mode: " + _this.getZoneModeText(_this.mode) + "</br>\n                    Compenator: " + _this.compensatorValue;
              return result;
            } catch (Exception) {
              return "";
            }
          },
          textStyle: {
            fontSize: 12
          }
        },

        legend: {
          data: ["OAT", "Valve Current Position", "Valve Target Position"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [{
          type: "value",
          name: "Temperature",
          min: 0,
          max: 110,
          axisLabel: { formatter: "{value} °F" }
        }, {
          type: "value",
          name: "Valve Position",
          min: 0,
          max: 100,
          axisLabel: { formatter: "{value} %" }
        }],
        series: [{
          name: "OAT",
          type: "line",

          showSymbol: false,
          data: this.zoneTemperatureHistoryData
        }, {
          name: "Valve Current Position",
          type: "line",

          showSymbol: false,
          yAxisIndex: 1,
          data: this.zoneMotorCurrentPositionHistoryData
        }, {
          name: "Valve Target Position",
          type: "line",
          lineStyle: {
            type: "dashed"
          },
          showSymbol: false,
          yAxisIndex: 1,
          data: this.zoneMotorTargetPositionHistoryData
        }]
      });
    },
    drawPressureLineChart: function drawPressureLineChart(zoneID) {
      this.chartPressureLine = _echarts2.default.init(document.getElementById("chartPressureLine"));
      this.chartPressureLine.setOption({
        title: {
          text: "Pressure"
        },
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: function formatter(params) {
            var now = new Date(params[0].value[0]);
            var dateFormatted = (0, _dateformat2.default)(now, "m-dd-yyyy, h:MM TT");
            try {
              var result = "\n                    Time: " + dateFormatted + "</br>\n                    Boiler Pressure: " + params[0].value[1].toFixed(1) + " PSI</br>\n                    Return Pressure: " + params[1].value[1].toFixed(1) + " \"inHg</br>\n                    Supply Pressure: " + params[2].value[1].toFixed(1) + " \"inHg</br>";
              return result;
            } catch (Exception) {
              return "";
            }
          },
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          data: ["Boiler Pressure", "Return Pressure", "Supply Pressure"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [{
          type: "value",
          name: "Pressure (PSI)",
          min: -10,
          max: 10,
          axisLabel: { formatter: "{value} PSI" }
        }, {
          type: "value",
          name: "Pressure (\"Hg)",
          min: -35.36,
          max: 35.36,
          axisLabel: { formatter: "{value} \"inHg" }
        }],
        series: [{
          name: "Boiler Pressure",
          type: "line",

          showSymbol: false,
          data: this.zonePressureBoilerHistoryData
        }, {
          name: "Return Pressure",
          type: "line",

          showSymbol: false,
          yAxisIndex: 1,
          data: this.zonePressureReturnHistoryData
        }, {
          name: "Supply Pressure",
          type: "line",
          showSymbol: false,
          yAxisIndex: 1,
          data: this.zonePressureSupplyHistoryData
        }]
      });
    },
    drawExTemperatureLineChart: function drawExTemperatureLineChart(zoneID) {
      this.chartExTemperatureLine = _echarts2.default.init(document.getElementById("chartExTemperatureLine"));
      this.chartExTemperatureLine.setOption({
        title: {
          text: "Return and Domestic Water Temp"
        },
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: function formatter(params) {
            var now = new Date(params[0].value[0]);
            var dateFormatted = (0, _dateformat2.default)(now, "m-dd-yyyy, h:MM TT");
            try {
              var result = "\n                    Time: " + dateFormatted + "</br>\n                    Return Temp: " + params[0].value[1].toFixed(1) + " \xB0F</br>\n                    Domestic Water Temp: " + params[1].value[1].toFixed(1) + " \xB0F</br>\n                    Aux: " + params[1].value[1].toFixed(1) + " \xB0F</br>";
              return result;
            } catch (Exception) {
              return "";
            }
          },
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          data: ["Return Temp", "Domestic Water Temp", "Aux"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [{
          type: "value",
          name: "Temperature",

          axisLabel: { formatter: "{value} °F" }
        }],
        series: [{
          name: "Return Temp",
          type: "line",

          showSymbol: false,
          data: this.zoneReturnTemperatureHistoryData
        }, {
          name: "Domestic Water Temp",
          type: "line",

          showSymbol: false,

          data: this.zoneDomesticWaterTemperatureHistoryData
        }, {
          name: "Aux",
          type: "line",

          showSymbol: false,

          data: this.zoneAuxHistoryData
        }]
      });
    },
    getZoneMode: function getZoneMode(time) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var modeResult;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _io2.default.getZoneMode(_this2.user.activeZone, time);

              case 2:
                modeResult = _context.sent;

                if (modeResult.data.length > 0) {
                  _this2.mode = modeResult.data[0].mode;
                } else {
                  _this2.mode = 'NA';
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getZoneCompensatorSetting: function getZoneCompensatorSetting(time) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var compensatorResult;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _io2.default.getZoneCompensatorSetting(_this3.user.activeZone, time);

              case 2:
                compensatorResult = _context2.sent;

                if (compensatorResult.data.length < 1) {
                  _this3.compensatorValue = "NA";
                } else {
                  _this3.compensatorValue = compensatorResult.data[0].compensatorValue;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getZoneHistory: function getZoneHistory() {
      var _this4 = this;

      var toDate = this.toDate;
      toDate.setUTCHours(23);
      toDate.setUTCMinutes(59);
      var toDateFormatted = toDate.toISOString();
      var fromDateFormatted = this.fromDate.toISOString();
      _axios2.default.all([_io2.default.getZoneTemperatureHistory(this.user.activeZone, fromDateFormatted, toDateFormatted), _io2.default.getZoneMonitorCurrentPositionHistory(this.user.activeZone, fromDateFormatted, toDateFormatted), _io2.default.getZoneMonitorTargetPositionHistory(this.user.activeZone, fromDateFormatted, toDateFormatted), _io2.default.getZonePressureBoilerHistory(this.user.activeZone, fromDateFormatted, toDateFormatted)]).then(_axios2.default.spread(function (ZoneTemperatureResponse, ZoneMotorCurrentPositionResponse, ZoneMotorTargetPositionResponse, ZonePressureBoilerResponse) {
        _this4.zoneTemperatureHistoryData = [];
        _this4.zoneMotorCurrentPositionHistoryData = [];
        _this4.zoneMotorTargetPositionHistoryData = [];
        _this4.zonePressureBoilerHistoryData = [];
        _this4.zonePressureSupplyHistoryData = [];
        _this4.zonePressureReturnHistoryData = [];
        _this4.zoneReturnTemperatureHistoryData = [];
        _this4.zoneDomesticWaterTemperatureHistoryData = [];
        _this4.zoneAuxHistoryData = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(ZoneTemperatureResponse.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _this4.zoneTemperatureHistoryData.push([item.time, item.temperature]);
            _this4.zoneReturnTemperatureHistoryData.push([item.time, item.returnLine]);
            _this4.zoneDomesticWaterTemperatureHistoryData.push([item.time, item.domesticWater]);
            _this4.zoneAuxHistoryData.push([item.time, item.auxiliary]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(ZoneMotorCurrentPositionResponse.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            _this4.zoneMotorCurrentPositionHistoryData.push([_item.time, _item.currentPosition]);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(ZoneMotorTargetPositionResponse.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item2 = _step3.value;

            _this4.zoneMotorTargetPositionHistoryData.push([_item2.time, _item2.targetPosition]);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = (0, _getIterator3.default)(ZonePressureBoilerResponse.data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _item3 = _step4.value;

            _this4.zonePressureBoilerHistoryData.push([_item3.time, _item3.boiler]);
            if (_item3.boiler == null) {
              _this4.zonePressureSupplyHistoryData.push([_item3.time, null]);
              _this4.zonePressureReturnHistoryData.push([_item3.time, null]);
            } else {
              _this4.zonePressureSupplyHistoryData.push([_item3.time, _item3.supply * 2.036]);
              _this4.zonePressureReturnHistoryData.push([_item3.time, _item3.return * 2.036]);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this4.csvArray = [];
        _this4.csvArray.push(['time', 'Outdoor Temperature (°F)', 'Return Temperature (°F)', 'Domestic Water (°F)', 'Valve Current Position (%)', 'Valve Target Position (%)', 'Boiler Pressure (PSI)', 'Supply Pressure (inHg)', 'Return Pressure (inHg)']);
        for (var index = 0; index < ZoneTemperatureResponse.data.length; index++) {
          if (ZoneTemperatureResponse.data[index].temperature != null) {
            var date = new Date(ZoneTemperatureResponse.data[index].time);

            _this4.csvArray.push([date.toString(), ZoneTemperatureResponse.data[index].temperature, ZoneTemperatureResponse.data[index].returnLine, ZoneTemperatureResponse.data[index].domesticWater, ZoneMotorCurrentPositionResponse.data[index].currentPosition, ZoneMotorTargetPositionResponse.data[index].targetPosition, ZonePressureBoilerResponse.data[index].boiler, ZonePressureBoilerResponse.data[index].supply * 2.036, ZonePressureBoilerResponse.data[index].return * 2.036]);
          }
        }

        _this4.drawLineChart(_this4.user.activeZone);
        _this4.drawPressureLineChart(_this4.user.activeZone);
        _this4.drawExTemperatureLineChart(_this4.user.activeZone);
      }));
    },
    toFahrenheit: function toFahrenheit(degC) {
      console.log(degC);
      if (typeof degC === "undefined") {
        return "";
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F";
      }
    },
    compare: function compare(a, b) {
      return a.floor < b.floor ? 1 : -1;
    },
    isInArray: function isInArray(floor) {
      for (var i = 0; i < this.apartmentSensorStatus.length; i++) {
        if (this.apartmentSensorStatus[i].floor == floor) {
          return i;
        }
      }
      return -1;
    }
  },

  mounted: function mounted() {
    var yesterday = new Date();
    yesterday.setDate(new Date().getDate() - 8);
    this.fromDate = yesterday;
    this.fromDateCalendar = yesterday.toISOString();

    this.getZoneHistory();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  },

  updated: function updated() {}
};

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hashParse = __webpack_require__(1211);

var _hashParse2 = _interopRequireDefault(_hashParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'callback',
  data: function data() {
    return {
      message: 'Loading..'
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log("handling auth");
    console.log(this.$route);
    var result = _hashParse2.default.parse(this.$route.hash);
    if (result.error) {
      this.message = decodeURI(result.error_description) + "   This page will automatically redirect to the login page in 5 seconds";
      setTimeout(function () {
        _this.$auth.handleAuthentication().then(function (data) {
          _this.$router.push({ name: 'Dashboard' });
        });
      }, 5000);
    } else {
      this.$auth.handleAuthentication().then(function (data) {
        _this.$router.push({ name: 'Dashboard' });
      });
    }
  }
};

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(128);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _vueNumkeyboard = __webpack_require__(317);

var _vueNumkeyboard2 = _interopRequireDefault(_vueNumkeyboard);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _apartments = __webpack_require__(162);

var _apartments2 = _interopRequireDefault(_apartments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  props: {},
  data: function data() {
    return {
      polling: null,
      user: this.$session.get("User"),
      fullLoading: false,
      adminLock: false,
      modeDialog: {
        visible: false,
        form: {
          mode: "ValveSet",
          valveSet: "Closed",
          manualPosition: "",
          currentManualPosition: ""
        },
        valveSetOptionsVisible: false,
        manualSetOptionsVisible: false,
        timeout: 0,
        loading: false
      },
      editDialog: {
        visible: false,
        loading: false,
        value: "",
        title: "",
        currentValue: "",
        timeout: 0
      },

      sysHeatStatusTable: [{
        mode: "Auto",
        operation: "Winter",
        period: "Heatup",
        network: "Connected"
      }],
      apartmentSensorsAvailable: false,
      apartmentSensorMetrics: [{
        average: "75 F",
        totalSensors: 30,
        onlineSensors: 28,
        networkHealth: "95%"
      }],
      heatBalancerTable: [{
        none: "",
        valueBottom: "",
        valueTop: "",
        valueDifference: ""
      }],
      temperatureSensorsTable: [{
        sensor: "Return Line",
        value: ""
      }, {
        sensor: "Domestic Water",
        value: ""
      }, {
        sensor: "Stack",
        value: ""
      }, {
        sensor: "Aux",
        value: ""
      }],
      pressureSensorsTable: [{
        sensor: "Boiler",
        value: ""
      }, {
        sensor: "Supply",
        value: ""
      }, {
        sensor: "Return",
        value: ""
      }, {
        sensor: "Differential",
        value: ""
      }],
      sysStatusTable: [{
        outdoorTemperature: "",
        motorCurrentPosition: "",
        motorTargetPosition: "",
        compensator: ""
      }],
      dataLoaded: false,
      motorCurrentPosition: 0,
      motorTargetPosition: 0,
      compensatorValue: -2,
      supplyPressureValue: 4,
      boilerPressureValue: -15,
      outputTable: [{
        name: "Boiler",
        control: false,
        value: false
      }, {
        name: "Vacuum Pump",
        control: false,
        value: false
      }, {
        name: "Differential",
        control: false,
        value: false
      }, {
        name: "Flood Alarm",
        control: false,
        value: false
      }],
      inputTable: [{
        name: "Air Pump 1",
        value: false
      }, {
        name: "Air Pump 2",
        value: false
      }, {
        name: "Condensate 1",
        value: false
      }, {
        name: "Condensate 2",
        value: false
      }]
    };
  },

  methods: {
    toFahrenheit: function toFahrenheit(degC) {
      console.log(degC);
      if (typeof degC === "undefined") {
        return "";
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F";
      }
    },
    modeDialogChangeValue: function modeDialogChangeValue(data) {
      if (data == "ValveSet") {
        this.modeDialog.valveSetOptionsVisible = true;
      } else {
        this.modeDialog.valveSetOptionsVisible = false;
      }
      if (data == "Manual") {
        this.modeDialog.manualSetOptionsVisible = true;
      } else {
        this.modeDialog.manualSetOptionsVisible = false;
      }
    },
    sysOperationClick: function sysOperationClick(row, column, cell, event) {
      if (column.property == "mode") {
        this.modeDialog.visible = true;
        if (this.modeDialog.form.mode == "ValveSet") this.modeDialog.valveSetOptionsVisible = true;else if (this.modeDialog.form.mode == "Manual") this.modeDialog.manualSetOptionsVisible = true;
        this.modeDialog.form.manualPosition = "";
      }
    },
    sysStatusClick: function sysStatusClick(row, column, cell, event) {
      if (column.property == "compensator") {
        this.editDialog.title = "Compensator";
        this.editDialog.visible = true;
        this.editDialog.value = "";
        this.editDialog.currentValue = this.sysStatusTable[0].compensator;
      }
    },
    sleep: function sleep(ms) {
      return new _promise2.default(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    checkCompensator: function checkCompensator() {
      this.getData();
      this.editDialog.timeout--;
      if (this.editDialog.timeout <= 0) {
        this.editDialog.visible = false;
        this.editDialog.loading = false;
        var h = this.$createElement;
        this.$notify({
          title: "Compensator",
          message: "Error trying to save setting to panel",
          type: "error"
        });
      } else if (this.editDialog.value != this.sysStatusTable[0].compensator) {
        setTimeout(this.checkCompensator, 500);
      } else {
        this.editDialog.visible = false;
        this.editDialog.loading = false;
      }
    },
    editDialogHandler: function editDialogHandler() {
      var _this = this;

      if (this.editDialog.title == "Compensator") {
        if (this.editDialog.value < _system2.default.COMPENSATOR.min || this.editDialog.value > _system2.default.COMPENSATOR.max || isNaN(parseInt(this.editDialog.value))) {
          var h = this.$createElement;
          this.$notify({
            title: "Compensator",
            message: "Compensator value should be betweeen " + _system2.default.COMPENSATOR.min + " and " + _system2.default.COMPENSATOR.max,
            type: "warning"
          });
        } else {
          this.editDialog.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Compensator.Value", this.editDialog.value)]).then(_axios2.default.spread(function (changeSettingResponse) {
            if (changeSettingResponse.data.result != "success") {
              _this.editDialog.loading = false;
              var _h = _this.$createElement;
              _this.$notify({
                title: "Compensator",
                message: "Error trying to save setting to panel",
                type: "error"
              });
            } else {
              setTimeout(function () {
                _this.editDialog.visible = false;
                _this.editDialog.loading = false;
                _this.getData();
              }, 5000);
            }
          }));
        }
      }
    },
    checkModeOnly: function checkModeOnly() {
      this.getData();
      this.modeDialog.timeout--;
      if (this.modeDialog.timeout <= 0) {
        this.modeDialog.visible = false;
        this.modeDialog.loading = false;
        var h = this.$createElement;
        this.$notify({
          title: "Mode",
          message: "Error trying to save mode to panel",
          type: "error"
        });
      } else if (this.modeDialog.form.mode != this.sysHeatStatusTable[0].mode) {
        setTimeout(this.checkModeOnly, 500);
      } else {
        this.modeDialog.visible = false;
        this.modeDialog.loading = false;
      }
    },
    modeDialogHandler: function modeDialogHandler(data) {
      var _this2 = this;

      switch (this.modeDialog.form.mode) {
        case "Auto":
        case "Program Mode":
        case "Pause":
        case "Off":
          this.modeDialog.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode)]).then(_axios2.default.spread(function (changeSettingResponse) {
            if (changeSettingResponse.data.result != "success") {
              _this2.modeDialog.loading = false;
              var h = _this2.$createElement;
              _this2.$notify({
                title: "Mode",
                message: "Error trying to save mode to panel",
                type: "error"
              });
            } else {
              setTimeout(function () {
                _this2.modeDialog.visible = false;
                _this2.modeDialog.loading = false;
                _this2.getData();
              }, 5000);
            }
          }));
          break;
        case "ValveSet":
          this.modeDialog.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode), _settings2.default.changeSetting(this.user.activeZone, "Settings.Mode.ValveSet.Value", this.modeDialog.form.valveSet)]).then(_axios2.default.spread(function (changeSettingResponse, changeValveSetResponse) {
            if (changeSettingResponse.data.result != "success" && changeValveSetResponse.data.result != "success") {
              _this2.modeDialog.loading = false;
              var h = _this2.$createElement;
              _this2.$notify({
                title: "Mode",
                message: "Error trying to save mode to panel",
                type: "error"
              });
            } else {
              setTimeout(function () {
                _this2.modeDialog.visible = false;
                _this2.modeDialog.loading = false;
                _this2.getData();
              }, 5000);
            }
          }));
          break;
        case "Manual":
          this.modeDialog.loading = true;
          if (this.modeDialog.form.manualPosition == "") {
            this.modeDialog.form.manualPosition = this.modeDialog.form.currentManualPosition;
          }
          if (parseFloat(this.modeDialog.form.manualPosition) < _system2.default.MOTOR_MANUAL_POSITION.min || parseFloat(this.modeDialog.form.manualPosition) > _system2.default.MOTOR_MANUAL_POSITION.max) {
            var h = this.$createElement;

            this.$notify({
              title: "Valve Set Position",
              message: "Valve Set Position should be between " + _system2.default.MOTOR_MANUAL_POSITION.min + " and " + _system2.default.MOTOR_MANUAL_POSITION.max,
              type: "warning"
            });
            this.modeDialog.loading = false;
          } else {
            _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Mode.Value", this.modeDialog.form.mode), _settings2.default.changeSetting(this.user.activeZone, "Settings.Mode.Manual.Value", this.modeDialog.form.manualPosition)]).then(_axios2.default.spread(function (changeSettingResponse, changeValveSetResponse) {
              if (changeSettingResponse.data.result != "success" && changeValveSetResponse.data.result != "success") {
                _this2.modeDialog.loading = false;
                var _h2 = _this2.$createElement;
                _this2.$notify({
                  title: "Mode",
                  message: "Error trying to save mode to panel",
                  type: "error"
                });
              } else {
                setTimeout(function () {
                  _this2.modeDialog.visible = false;
                  _this2.modeDialog.loading = false;
                  _this2.getData();
                }, 5000);
              }
            }));
          }
          break;
      }
    },
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    printTemperature: function printTemperature(result, enabled) {
      if (enabled) {
        if (result == -500) return "Error";else return result + "°F";
      } else {
        return "Disabled";
      }
    },
    printPressure: function printPressure(result, enabled) {
      if (enabled) {
        if (result == -500) return "Error";
        if (result >= 0) return result.toFixed(1) + " PSI";else return (result * -1 * 2.03602).toFixed(1) + " inHg";
      } else {
        return "Disabled";
      }
    },
    printPressurePSI: function printPressurePSI(result, enabled) {
      if (enabled) {
        if (result == -500) return "Error";else if (result > 0) return "+" + result.toFixed(1) + " PSI";else return result.toFixed(1) + " PSI";
      } else {
        return "Disabled";
      }
    },
    printPressureInHG: function printPressureInHG(result, enabled) {
      if (enabled) {
        if (result == -500) return "Error";else if (result > 0) return "+" + (result * 2.03602).toFixed(1) + " inHg";else return (result * 2.03602).toFixed(1) + " inHg";
      } else {
        return "Disabled";
      }
    },
    getData: function getData() {
      var _this3 = this;

      if (!this.$auth.isAuthenticated()) this.$auth.login();

      _axios2.default.all([_io2.default.getIO(this.user.activeZone), _io2.default.getApartmentAverage(this.user.activeZone), _io2.default.getSettings(this.user.activeZone), _io2.default.getOperationStatus(this.user.activeZone), _apartments2.default.getApartmentsMetrics(this.user.activeZone)]).then(_axios2.default.spread(function (IOResponse, ApartmentAverageResponse, SettingsResponse, OperationStatusResponse, ApartmentsMetrics) {
        if (typeof IOResponse.data.error !== "undefined") {
          _this3.sysHeatStatusTable[0].network = "Panel Disconnected";
          return;
        } else {
          _this3.sysHeatStatusTable[0].network = "Panel Connected";
        }

        _this3.sysStatusTable[0].outdoorTemperature = _this3.printTemperature(IOResponse.data.sensors.temperature.outdoor.toFixed(1), true);
        _this3.sysStatusTable[0].motorCurrentPosition = IOResponse.data.motor.currentPosition.toFixed(0) + "%";
        _this3.sysStatusTable[0].motorTargetPosition = IOResponse.data.motor.targetPosition.toFixed(0) + "%";

        _this3.temperatureSensorsTable[0].value = _this3.printTemperature(IOResponse.data.sensors.temperature.returnLine.toFixed(1), SettingsResponse.data.sensors.temperature.returnLine.enabled == "true");
        _this3.temperatureSensorsTable[1].value = _this3.printTemperature(IOResponse.data.sensors.temperature.domesticWater.toFixed(1), SettingsResponse.data.sensors.temperature.domesticWater.enabled == "true");
        _this3.temperatureSensorsTable[2].value = _this3.printTemperature(IOResponse.data.sensors.temperature.stack.toFixed(1), SettingsResponse.data.sensors.temperature.stack.enabled == "true");
        _this3.temperatureSensorsTable[3].value = _this3.printTemperature(IOResponse.data.sensors.temperature.aux.toFixed(1), SettingsResponse.data.sensors.temperature.aux.enabled == "true");

        _this3.pressureSensorsTable[0].value = _this3.printPressurePSI(IOResponse.data.sensors.pressure.boiler, SettingsResponse.data.sensors.pressure.boiler.enabled == "true");
        _this3.pressureSensorsTable[1].value = _this3.printPressureInHG(IOResponse.data.sensors.pressure.supply, SettingsResponse.data.sensors.pressure.supply.enabled == "true");
        _this3.pressureSensorsTable[2].value = _this3.printPressureInHG(IOResponse.data.sensors.pressure.return, SettingsResponse.data.sensors.pressure.return.enabled == "true");

        var differentialPossible = SettingsResponse.data.sensors.pressure.supply.enabled == "true" && SettingsResponse.data.sensors.pressure.return.enabled == "true";
        if (differentialPossible) {
          if (IOResponse.data.sensors.pressure.supply != -500 || IOResponse.data.sensors.pressure.return != -500) {
            _this3.pressureSensorsTable[3].value = _this3.printPressureInHG(IOResponse.data.sensors.pressure.supply - IOResponse.data.sensors.pressure.return, differentialPossible);
            _this3.pressureSensorsTable[3].raw = IOResponse.data.sensors.pressure.supply - IOResponse.data.sensors.pressure.return;
          } else {
            _this3.pressureSensorsTable[3].value = "Error";
          }
        }

        console.log(SettingsResponse.data);
        console.log(ApartmentAverageResponse.data);

        _this3.heatBalancerTable[0].valueBottom = _this3.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.bottom.toFixed(1), SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true");
        _this3.heatBalancerTable[0].valueTop = _this3.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.top.toFixed(1), SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true");
        _this3.heatBalancerTable[0].valueDifference = _this3.printTemperature((IOResponse.data.sensors.temperature.heatBalancer.top - IOResponse.data.sensors.temperature.heatBalancer.bottom).toFixed(1), SettingsResponse.data.sensors.temperature.heatBalancer.enabled == "true");

        _this3.outputTable[0].control = SettingsResponse.data.digitalOutputs.boiler.control == "Manual";
        _this3.outputTable[1].control = SettingsResponse.data.digitalOutputs.vacuumPump.control == "Manual";
        _this3.outputTable[2].control = SettingsResponse.data.digitalOutputs.differential.control == "Manual";
        _this3.outputTable[3].control = SettingsResponse.data.digitalOutputs.floodAlarm.control == "Manual";
        console.log(IOResponse.data);
        if (SettingsResponse.data.digitalOutputs.boiler.control == "Manual") _this3.outputTable[0].value = SettingsResponse.data.digitalOutputs.boiler.manualState == "true";else _this3.outputTable[0].value = IOResponse.data.digitalOutputs.boiler == "true";

        if (SettingsResponse.data.digitalOutputs.vacuumPump.control == "Manual") _this3.outputTable[1].value = SettingsResponse.data.digitalOutputs.vacuumPump.manualState == "true";else _this3.outputTable[1].value = IOResponse.data.digitalOutputs.vacuum == "true";

        if (SettingsResponse.data.digitalOutputs.differential.control == "Manual") _this3.outputTable[2].value = SettingsResponse.data.digitalOutputs.differential.manualState == "true";else _this3.outputTable[2].value = IOResponse.data.digitalOutputs.differential == "true";

        if (SettingsResponse.data.digitalOutputs.floodAlarm.control == "Manual") _this3.outputTable[3].value = SettingsResponse.data.digitalOutputs.floodAlarm.manualState == "true";else _this3.outputTable[3].value = IOResponse.data.digitalOutputs.floodAlarm == "true";

        _this3.inputTable[0].value = IOResponse.data.digitalInputs.airPump_1 == "true";
        _this3.inputTable[1].value = IOResponse.data.digitalInputs.airPump_2 == "true";
        _this3.inputTable[2].value = IOResponse.data.digitalInputs.condensate_1 == "true";
        _this3.inputTable[3].value = IOResponse.data.digitalInputs.condensate_2 == "true";

        if (!_this3.modeDialog.visible) {
          _this3.modeDialog.form.currentManualPosition = SettingsResponse.data.mode.manual.value;
          _this3.modeDialog.form.valveSet = SettingsResponse.data.mode.valveSet.value;
          _this3.modeDialog.form.mode = SettingsResponse.data.mode.value;
        }

        _this3.sysStatusTable[0].compensator = SettingsResponse.data.compensator.value;


        switch (SettingsResponse.data.mode.value) {
          case "Auto":
          case "Program Mode":
          case "Pause":
          case "Off":
            _this3.sysHeatStatusTable[0].mode = SettingsResponse.data.mode.value;
            break;
          case "Manual":
            _this3.sysHeatStatusTable[0].mode = "Valve Set";
            break;
          case "ValveSet":
            _this3.sysHeatStatusTable[0].mode = "Manual";
            break;
        }
        _this3.sysHeatStatusTable[0].operation = OperationStatusResponse.data.operation.season;
        _this3.sysHeatStatusTable[0].period = OperationStatusResponse.data.operation.period;

        if (ApartmentsMetrics.data != null && ApartmentsMetrics.data.totalSensors > 0) {
          _this3.apartmentSensorsAvailable = true;
          _this3.apartmentSensorMetrics[0].average = _this3.toFahrenheit(ApartmentsMetrics.data.temperatureAverage);
          _this3.apartmentSensorMetrics[0].totalSensors = ApartmentsMetrics.data.totalSensors;
          _this3.apartmentSensorMetrics[0].onlineSensors = ApartmentsMetrics.data.totalSensorsOnline;
          _this3.apartmentSensorMetrics[0].networkHealth = (ApartmentsMetrics.data.totalSensorsOnline / ApartmentsMetrics.data.totalSensors * 100).toFixed(0) + "%";
        } else {
          _this3.apartmentSensorsAvailable = false;
        }

        _this3.dataLoaded = true;
      })).catch(function (err) {
        _this3.sysHeatStatusTable[0].network = "Error in Server and/or Panel";
        console.log(err);
      });
    },
    digitalOutputControl: function digitalOutputControl(event, id) {
      switch (id) {
        case "Boiler":
          break;
        case "Vacuum Pump":
          break;
        case "Differential":
          break;
        case "Flood Alarm":
          break;
      }
    },
    checkDigitalOutput: function checkDigitalOutput(key, value, timeout) {
      this.getData();
      timeout--;
      if (timeout <= 0) {
        this.fullLoading = false;
        var h = this.$createElement;
        this.$notify({
          title: "Digital Outputs",
          message: "Error trying to save mode to panel",
          type: "error"
        });
      } else {
        switch (key) {
          case "Settings.DigitalOutputs.Boiler.Control":
            if (this.outputTable[0].control == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.VacuumPump.Control":
            if (this.outputTable[1].control == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.Differential.Control":
            if (this.outputTable[2].control == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.FloodAlarm.Control":
            if (this.outputTable[3].control == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.Boiler.ManualState":
            if (this.outputTable[0].value == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.VacuumPump.ManualState":
            if (this.outputTable[1].value == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.Differential.ManualState":
            if (this.outputTable[2].value == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
          case "Settings.DigitalOutputs.FloodAlarm.ManualState":
            if (this.outputTable[3].value == value) {
              this.fullLoading = false;
            } else {
              setTimeout(this.checkDigitalOutput, 500, key, value, timeout);
            }
            break;
        }
      }
    },
    digitalOutputControlValue: function digitalOutputControlValue(event, id) {
      var _this4 = this;

      if (this.user.role == "buildingAdmin") return;
      var key = "";
      var value = false;
      switch (id) {
        case "Boiler":
          key = "Settings.DigitalOutputs.Boiler.Control";
          value = !this.outputTable[0].control;
          break;
        case "Vacuum Pump":
          key = "Settings.DigitalOutputs.VacuumPump.Control";
          value = !this.outputTable[1].control;
          break;
        case "Differential":
          key = "Settings.DigitalOutputs.Differential.Control";
          value = !this.outputTable[2].control;
          break;
        case "Flood Alarm":
          key = "Settings.DigitalOutputs.FloodAlarm.Control";
          value = !this.outputTable[3].control;
          break;
      }

      console.log(key + "-" + value);
      this.fullLoading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, key, value ? "Manual" : "Auto")]).then(_axios2.default.spread(function (settingChangeResponse) {
        if (settingChangeResponse.data.result != "success") {
          _this4.fullLoading = false;
          var h = _this4.$createElement;
          _this4.$notify({
            title: "Digital Output",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this4.checkDigitalOutput(key, value, 20);
        }
      })).catch(function () {
        _this4.fullLoading = false;
        var h = _this4.$createElement;
        _this4.$notify({
          title: "Digital Output",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    digitalOutputManualValue: function digitalOutputManualValue(event, id) {
      var _this5 = this;

      if (this.user.role == "buildingAdmin") return;
      var key = "";
      var value = false;
      switch (id) {
        case "Boiler":
          if (!this.outputTable[0].control) return;
          key = "Settings.DigitalOutputs.Boiler.ManualState";
          value = !this.outputTable[0].value;
          break;
        case "Vacuum Pump":
          if (!this.outputTable[1].control) return;
          key = "Settings.DigitalOutputs.VacuumPump.ManualState";
          value = !this.outputTable[1].value;
          break;
        case "Differential":
          if (!this.outputTable[2].control) return;
          key = "Settings.DigitalOutputs.Differential.ManualState";
          value = !this.outputTable[2].value;
          break;
        case "Flood Alarm":
          if (!this.outputTable[3].control) return;
          key = "Settings.DigitalOutputs.FloodAlarm.ManualState";
          value = !this.outputTable[3].value;
          break;
      }

      console.log(key + "-" + value);
      this.fullLoading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, key, value ? "true" : "false")]).then(_axios2.default.spread(function (settingChangeResponse) {
        if (settingChangeResponse.data.result != "success") {
          _this5.fullLoading = false;
          var h = _this5.$createElement;
          _this5.$notify({
            title: "Digital Output",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this5.checkDigitalOutput(key, value, 20);
        }
      })).catch(function () {
        _this5.fullLoading = false;
        var h = _this5.$createElement;
        _this5.$notify({
          title: "Digital Output",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
    this.polling = setInterval(this.getData, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  }
};

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

var _dateformat = __webpack_require__(183);

var _dateformat2 = _interopRequireDefault(_dateformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      zone: {
        name: ""
      },
      currentDateTime: "",
      dateUpdatePolling: null,
      componentKey: 0,
      lockDialog: {
        value: "",
        visible: false
      },
      sysName: "Vari-VAC Online",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      user: this.$session.get("User"),
      userBillingDue: 365
    };
  },

  methods: {
    profileClick: function profileClick() {
      this.$router.push("/Profile");
    },
    billingDueClick: function billingDueClick() {
      this.$router.push("/ZonesDashboard");
    },
    updateDateTime: function updateDateTime() {
      var now = new Date();
      this.currentDateTime = (0, _dateformat2.default)(now, "dddd, mmmm dS, yyyy, h:MM:ss TT");
    },
    getZoneName: function getZoneName(zoneid) {
      switch (zoneid) {
        case "00000000828a3f7d":
          return "920 Metcalf - Zone A";
        case "G6AY90300A7E":
          return "WestWinds - ZoneA";
      }
    },
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        sessionStorage.removeItem("user");
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.dateUpdatePolling = setInterval(this.updateDateTime, 1000);
    this.updateDateTime();
    var user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.name || "";
      this.sysUserAvatar = user.picture || "";
      console.log(user.picture);
    }
    _axios2.default.all([_user2.default.getZone(this.user.activeZone), _user2.default.getUserBillingDue(this.user)]).then(_axios2.default.spread(function (zoneResponse, userBillingResponse) {
      _this2.zone = zoneResponse.data;
      if (userBillingResponse.data) {
        _this2.userBillingDue = userBillingResponse.data.billingDue;
      }
    }));
    this.$root.$on("zoneChanged", function () {
      _this2.user = _this2.$session.get("User");
      console.log(_this2.user);
      _axios2.default.all([_user2.default.getZone(_this2.user.activeZone), _user2.default.getUserBillingDue(_this2.user)]).then(_axios2.default.spread(function (zoneResponse, userBillingResponse) {
        _this2.zone = zoneResponse.data;
        if (userBillingResponse.data) {
          _this2.userBillingDue = userBillingResponse.data.billingDue;
        }
      }));
      console.log("changed");
    });
    if (this.user.role != "admin") {
      switch (this.user.role) {
        case "buildingAdminAdvanced":
          this.$router.options.routes.forEach(function (route) {
            switch (route.name) {
              case 'Zone Notes':
              case 'Zone Alarms':
              case 'Zone Logs':
              case 'Zone Notes':
              case 'ZoneInfo':
              case 'ZoneUsers':
              case 'UsersManager':
                route.hidden = true;
                break;
              default:
                break;
            }
          });
          break;
        case "buildingAdmin":
          this.$router.options.routes.forEach(function (route) {
            switch (route.name) {
              case 'Zone Notes':
              case 'Zone Alarms':
              case 'Zone Logs':
              case 'ZoneInfo':
              case 'ZoneUsers':
              case 'UsersManager':
              case 'Settings':
                route.hidden = true;
                break;
              default:
                break;
            }
          });
          break;
        default:
          this.$router.options.routes.forEach(function (route) {
            route.hidden = true;
          });
          break;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.dateUpdatePolling);
  }
};

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(128);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _notes = __webpack_require__(621);

var _notes2 = _interopRequireDefault(_notes);

var _apartments = __webpack_require__(162);

var _apartments2 = _interopRequireDefault(_apartments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  props: {},
  data: function data() {
    return {
      fullLoading: false,
      user: this.$session.get("User"),
      noteDialog: {
        visible: false,
        idVisible: false,
        form: {
          noteId: "ddddd",
          dateCreated: "",
          userCreated: "",
          note: "",
          newNote: false
        },
        valveSetOptionsVisible: false,
        manualSetOptionsVisible: false,
        timeout: 0,
        loading: false
      },
      dataLoaded: false,
      notesTable: []

    };
  },

  methods: {
    NoteDeleteHandler: function NoteDeleteHandler() {
      var _this = this;

      _notes2.default.deleteZoneNote(this.noteDialog.form.noteId).then(function () {
        _this.getData();
      });
      this.noteDialog.visible = false;
    },
    addNoteClick: function addNoteClick() {
      this.noteDialog.form.note = "";
      this.noteDialog.form.newNote = true;
      this.noteDialog.visible = true;
    },
    noteEditClick: function noteEditClick(row, column, cell, event) {
      this.noteDialog.form.noteId = row.id;
      this.noteDialog.form.dateCreated = row.created;
      this.noteDialog.form.userCreated = row.email;
      this.noteDialog.form.note = row.notes;
      this.noteDialog.form.newNote = false;
      this.noteDialog.visible = true;
    },
    sleep: function sleep(ms) {
      return new _promise2.default(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    NoteDialogHandler: function NoteDialogHandler() {
      var _this2 = this;

      if (this.noteDialog.form.newNote) {
        _notes2.default.addZoneNote(this.user.activeZone, this.user.email, this.noteDialog.form.note).then(function () {
          _this2.getData();
        });
      } else {
        _notes2.default.editZoneNote(this.noteDialog.form.noteId, this.noteDialog.form.note).then(function () {
          _this2.getData();
        });
      }
      this.noteDialog.visible = false;
    },
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    getData: function getData() {
      var _this3 = this;

      if (!this.$auth.isAuthenticated()) this.$auth.login();

      _axios2.default.all([_notes2.default.getZoneNotes(this.user.activeZone)]).then(_axios2.default.spread(function (ZoneNotesResponse) {
        console.log(ZoneNotesResponse.data);
        _this3.notesTable = ZoneNotesResponse.data;
        _this3.dataLoaded = true;
      })).catch(function (err) {
        _this3.sysHeatStatusTable[0].network = "Error in Server and/or Panel";
        console.log(err);
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
  },
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {
                notifications: false
            },
            user: this.$session.get("User")
        };
    },
    mounted: function mounted() {
        form.notifications = this.$session.get("User").notifications == 1;
    },

    methods: {
        updateUser: function updateUser() {
            var _this = this;

            _user2.default.updateUserNotifications(this.user.email, this.form.notifications).then(function (response) {
                if (response.data.error == null) {
                    var h = _this.$createElement;
                    _this.$notify({
                        title: "User Profile Updated",
                        message: "Update Success",
                        type: "info"
                    });
                    _this.getData();
                }
            });
        },
        getData: function getData() {
            var _this2 = this;

            _user2.default.getUser(this.user.email).then(function (response) {
                if (response.data.error == null) {
                    _this2.$session.set("User", response.data);
                }
            });
        }
    }
};

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                name: ""
            },
            allUsers: [],
            users: [],
            listLoading: false,
            user: this.$session.get("User"),
            userDeleteDialog: {
                title: "Delete User",
                visible: false,
                loading: false,
                form: {
                    email: ""
                }
            },
            userZonesDialog: {
                title: "Zones Accesible to User",
                visible: false,
                loading: false,
                form: {
                    email: "",
                    zones: []
                }
            }
        };
    },

    methods: {
        handleRemoveAccessZone: function handleRemoveAccessZone(zoneId) {
            var _this = this;

            console.log(zoneId);
            _user2.default.deleteUserAccessToZone(this.userZonesDialog.form.email, zoneId).then(function (result) {
                console.log(result);
                if (result.data.result != null && result.data.result == "success") {
                    _axios2.default.all([_user2.default.getUserZoneAccess(_this.userZonesDialog.form.email)]).then(_axios2.default.spread(function (userZoneAccessResponse) {
                        _this.userZonesDialog.form.zones = userZoneAccessResponse.data;
                    }));
                } else {
                    _this.$notify({
                        title: "User Zone Access",
                        message: result.data.error,
                        type: "error"
                    });
                }
            });
        },
        userDeleteClick: function userDeleteClick(index, row) {
            this.userDeleteDialog.form.email = row.email;
            this.userDeleteDialog.visible = true;
        },
        userDeleteDialogClick: function userDeleteDialogClick() {
            var _this2 = this;

            _user2.default.deleteUser(this.userDeleteDialog.form.email).then(function (result) {
                if (result.data.result != null && result.data.result == "success") {
                    _this2.$notify({
                        title: "User Delete",
                        message: "User Deleted",
                        type: "info"
                    });
                    _this2.getUsers();
                    _this2.userDeleteDialog.visible = false;
                } else {
                    _this2.$notify({
                        title: "User Delete",
                        message: result.data.error,
                        type: "error"
                    });
                    _this2.userDeleteDialog.visible = false;
                }
            });
        },
        userZonesClick: function userZonesClick(index, row) {
            var _this3 = this;

            _axios2.default.all([_user2.default.getUserZoneAccess(row.email)]).then(_axios2.default.spread(function (userZoneAccessResponse) {
                _this3.userZonesDialog.form.zones = userZoneAccessResponse.data;
            }));
            this.userZonesDialog.form.email = row.email;
            this.userZonesDialog.visible = true;
        },
        zoneEditClick: function zoneEditClick(index, row) {
            this.zoneDialog.title = "Edit Zone";
            this.zoneDialog.form.name = row.name;
            this.zoneDialog.form.deviceID = row.id;
            this.zoneDialog.form.zoneID = row.gsd_id;
            this.zoneDialog.form.boro = row.boro_id;
            this.zoneDialog.visible = true;
            this.zoneDialog.showPanelID = false;
        },
        zoneDeleteClick: function zoneDeleteClick(index, row) {
            var _this4 = this;

            this.$confirm("This will permanently delete the Zone. Continue?", "Warning", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning"
            }).then(function () {
                _axios2.default.all([_user2.default.deleteZone(row.id)]).then(_axios2.default.spread(function (deleteZoneResponse) {
                    if (deleteZoneResponse.data.result == "success") {
                        _this4.getZones();
                        _this4.$message({
                            type: "success",
                            message: "Delete completed"
                        });
                    } else {
                        _this4.$message({
                            type: "warning",
                            message: "Error Deleting Zone"
                        });
                    }
                }));
            }).catch(function () {
                _this4.$message({
                    type: "info",
                    message: "Delete canceled"
                });
            });
        },
        handleCurrentChange: function handleCurrentChange() {},
        filterUsers: function filterUsers() {
            var _this5 = this;

            if (this.filters.name.length > 0) {
                this.users = this.allUsers.filter(function (user) {
                    return user.email.toLowerCase().includes(_this5.filters.name.toLowerCase());
                });
            } else {
                this.users = this.allUsers;
            }
        },
        getUsers: function getUsers() {
            var _this6 = this;

            this.listLoading = true;
            _axios2.default.all([_user2.default.getUsers()]).then(_axios2.default.spread(function (usersResponse) {
                _this6.listLoading = false;
                _this6.allUsers = usersResponse.data;
                _this6.users = usersResponse.data;

                _this6.filterUsers();
            }));
            _axios2.default.all([_user2.default.getBoros()]).then(_axios2.default.spread(function (getBorosResponse) {
                _this6.boro_options = getBorosResponse.data;
            }));
        }
    },
    mounted: function mounted() {
        this.getUsers();
    }
};

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(128);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _alarms = __webpack_require__(620);

var _alarms2 = _interopRequireDefault(_alarms);

var _apartments = __webpack_require__(162);

var _apartments2 = _interopRequireDefault(_apartments);

var _util = __webpack_require__(163);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},
    props: {},
    data: function data() {
        return {
            fullLoading: false,
            user: this.$session.get("User"),
            alarmDialog: {
                visible: false,
                idVisible: false,
                form: {
                    id: "ddddd",
                    enabled: "",
                    threshold: "",
                    hysterisis: "",
                    name: "",
                    alarmTypeId: 1,
                    newAlarm: false
                },
                timeout: 0,
                loading: false,
                threshold: {
                    label: "Threshold (°F)",
                    visible: true
                },
                hysterisis: {
                    label: "Hysterisis (°F)",
                    visible: true
                }
            },
            dataLoaded: false,
            alarmsTable: [],
            alarmLogTable: [],
            alarmTypes: [{
                value: 1,
                label: 'Flood Alarm'
            }, {
                value: 2,
                label: 'Domestic Water High Temperature'
            }, {
                value: 3,
                label: 'Domestic Water Low Temperature'
            }, {
                value: 4,
                label: 'Boiler High Pressure'
            }, {
                value: 5,
                label: 'Boiler Low Pressure'
            }, {
                value: 6,
                label: 'Stack High Temperature'
            }, {
                value: 7,
                label: 'Stack Low Temperature'
            }]
        };
    },

    methods: {
        handleAlarmDialogFormat: function handleAlarmDialogFormat(alarmTypeId) {
            switch (alarmTypeId) {
                case 1:
                    this.alarmDialog.threshold.visible = false;
                    this.alarmDialog.hysterisis.visible = false;
                    break;
                case 2:
                case 3:
                case 6:
                case 7:
                    this.alarmDialog.threshold.visible = true;
                    this.alarmDialog.hysterisis.visible = true;
                    this.alarmDialog.threshold.label = "Threshold (°F)";
                    this.alarmDialog.hysterisis.label = "Hysterisis (°F)";
                    break;
                case 4:
                case 5:
                    this.alarmDialog.threshold.visible = true;
                    this.alarmDialog.hysterisis.visible = true;
                    this.alarmDialog.threshold.label = "Threshold (PSI)";
                    this.alarmDialog.hysterisis.label = "Hysterisis (PSI)";
                    break;
            }
        },
        alarmTypeChange: function alarmTypeChange() {
            console.log("David");
            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId);
        },
        AlarmDeleteHandler: function AlarmDeleteHandler() {
            var _this = this;

            _alarms2.default.deleteZoneAlarm(this.alarmDialog.form.id).then(function () {
                _this.getData();
            });
            this.alarmDialog.visible = false;
        },
        addAlarmClick: function addAlarmClick() {
            this.alarmDialog.form.note = "";

            this.alarmDialog.form.enabled = false;
            this.alarmDialog.form.threshold = null;
            this.alarmDialog.form.hysterisis = null;
            this.alarmDialog.form.name = "";
            this.alarmDialog.form.newAlarm = true;
            this.alarmDialog.form.alarmTypeId = 1;
            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId);
            this.alarmDialog.visible = true;
        },
        alarmEditClick: function alarmEditClick(row, column, cell, event) {
            this.alarmDialog.form.id = row.id;
            this.alarmDialog.form.enabled = row.enabled == 1;
            this.alarmDialog.form.threshold = row.threshold;
            this.alarmDialog.form.hysterisis = row.hysterisis;
            this.alarmDialog.form.name = row.name;
            this.alarmDialog.form.newAlarm = false;
            this.alarmDialog.form.alarmTypeId = row.alarm_type_id;

            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId);
            this.alarmDialog.visible = true;
        },
        sleep: function sleep(ms) {
            return new _promise2.default(function (resolve) {
                return setTimeout(resolve, ms);
            });
        },
        AlarmDialogHandler: function AlarmDialogHandler() {
            var _this2 = this;

            if (this.alarmDialog.form.newAlarm) {
                _alarms2.default.addZoneAlarm(this.user.activeZone, this.alarmDialog.form.alarmTypeId, this.alarmDialog.form.name, this.alarmDialog.form.enabled, this.alarmDialog.form.threshold, this.alarmDialog.form.hysterisis).then(function () {
                    _this2.getData();
                });
            } else {
                _alarms2.default.updateZoneAlarm(this.alarmDialog.form.id, this.alarmDialog.form.name, this.alarmDialog.form.enabled, this.alarmDialog.form.threshold, this.alarmDialog.form.hysterisis).then(function () {
                    _this2.getData();
                });
            }
            this.alarmDialog.visible = false;
        },
        onSubmit: function onSubmit() {
            console.log("submit!");
        },
        getData: function getData() {
            var _this3 = this;

            if (!this.$auth.isAuthenticated()) this.$auth.login();

            _axios2.default.all([_alarms2.default.getZoneAlarms(this.user.activeZone), _alarms2.default.getZoneAlarmLog(this.user.activeZone)]).then(_axios2.default.spread(function (ZoneAlarmsResponse, ZoneAlarmLogResponse) {
                console.log(ZoneAlarmsResponse.data);
                _this3.alarmsTable = ZoneAlarmsResponse.data;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_this3.alarmsTable), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var entry = _step.value;

                        if (entry.firedAt) {
                            entry.firedAtFormatted = _util2.default.formatDate.format(new Date(entry.firedAt), 'yyyy-MM-dd hh:mm');
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this3.alarmLogTable = ZoneAlarmLogResponse.data;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(_this3.alarmLogTable), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var entry = _step2.value;

                        if (entry.triggeredAt) {
                            entry.triggeredAtFormatted = _util2.default.formatDate.format(new Date(entry.triggeredAt), 'yyyy-MM-dd hh:mm');
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                _this3.dataLoaded = true;
            })).catch(function (err) {
                _this3.sysHeatStatusTable[0].network = "Error in Server and/or Panel";
                console.log(err);
            });
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.getData();
    },
    beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {},
      file: '',
      user: this.$session.get('User'),
      zoneImage: '',
      zoneImageSequence: 1
    };
  },
  mounted: function mounted() {
    this.zoneImage = "https://www.variablevac.com/hosting/img/zones/" + this.user.activeZone + ".jpg?t=" + this.zoneImageSequence++;
  },

  methods: {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitFile: function submitFile() {
      var _this = this;

      _user2.default.uploadZoneImage(this.user.activeZone, this.file).then(function (response) {
        if (response.data.result == 'success') {
          var h = _this.$createElement;
          _this.$notify({
            title: 'Image Upload',
            message: 'Sucess',
            type: 'info'
          });
          _this.zoneImage = "https://www.variablevac.com/hosting/img/zones/" + _this.user.activeZone + ".jpg?t=" + _this.zoneImageSequence++;
        } else {
          var _h = _this.$createElement;
          _this.$notify({
            title: 'Image Upload',
            message: response.data.result,
            type: 'error'
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

var _util = __webpack_require__(163);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},
    props: {},
    data: function data() {
        return {
            fullLoading: false,
            user: this.$session.get("User"),
            dataLoaded: false,
            allLogs: [],
            logsTable: [],
            filters: {
                name: ""
            }
        };
    },

    methods: {
        filterZones: function filterZones() {
            var _this = this;

            if (this.filters.name.length > 0) {
                this.logsTable = this.allLogs.filter(function (entry) {
                    return entry.category_type_name.toLowerCase().includes(_this.filters.name.toLowerCase()) || entry.log_type_name.toLowerCase().includes(_this.filters.name.toLowerCase()) || entry.type_name.toLowerCase().includes(_this.filters.name.toLowerCase());
                });
            } else {
                this.logsTable = this.allLogs;
            }
        },
        onSubmit: function onSubmit() {
            console.log("submit!");
        },
        getData: function getData() {
            var _this2 = this;

            if (!this.$auth.isAuthenticated()) this.$auth.login();

            _axios2.default.all([_user2.default.getZoneLog(this.user.activeZone)]).then(_axios2.default.spread(function (ZoneLogResponse) {
                console.log(ZoneLogResponse);
                _this2.allLogs = ZoneLogResponse.data;
                _this2.logsTable = ZoneLogResponse.data;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_this2.logsTable), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var entry = _step.value;

                        if (entry.time) {
                            entry.timeFormatted = _util2.default.formatDate.format(new Date(entry.time), 'yyyy-MM-dd hh:mm');
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this2.dataLoaded = true;
            })).catch(function (err) {
                console.log(err);
            });
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.getData();
    },
    beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                name: ""
            },
            allUsers: [],
            users: ["david.micallef86@gmail.com", "shana.vella@gmail.com"],
            listLoading: false,
            user: this.$session.get("User"),
            userDeleteDialog: {
                title: "Remove User from Zone",
                visible: false,
                loading: false,
                form: {
                    email: "",
                    password: ""
                }
            },
            addUserDialog: {
                title: "Add User",
                visible: false,
                loading: false,
                form: {
                    email: ""
                }
            },
            addExistingUserDialog: {
                title: "Add Existing User",
                visible: false,
                loading: false,
                selected: false,
                users: [],
                usersFiltered: [],
                form: {
                    email: ""
                }
            }
        };
    },

    methods: {
        addExistingUserDialogClick: function addExistingUserDialogClick() {
            var _this = this;

            if (this.addExistingUserDialog.form.email.length > 0 && this.addExistingUserDialog.selected) {
                _user2.default.addExistingUserToZone(this.addExistingUserDialog.form.email, this.user.activeZone).then(function (result) {
                    _this.addExistingUserDialog.visible = false;
                    _this.getZoneUsers();
                });
            }
        },
        handleSelect: function handleSelect(item) {
            this.addExistingUserDialog.selected = true;
        },
        querySearch: function querySearch(queryString, cb) {
            if (queryString.length > 0) {
                this.addExistingUserDialog.usersFiltered = this.addExistingUserDialog.users.filter(function (user) {
                    return user.value.toLowerCase().includes(queryString.toLowerCase());
                });
            } else {
                this.addExistingUserDialog.usersFiltered = this.addExistingUserDialog.users;
            }
            cb(this.addExistingUserDialog.usersFiltered);
        },
        addExistingUserClick: function addExistingUserClick() {
            this.addExistingUserDialog.form.email = "";
            this.addExistingUserDialog.visible = true;
            this.addExistingUserDialog.selected = false;
        },
        addUserClick: function addUserClick() {
            this.addUserDialog.form.email = "";
            this.addUserDialog.form.password = "";
            this.addUserDialog.form.role = "buildingAdminAdvanced";
            this.addUserDialog.visible = true;
        },
        addUserDialogClick: function addUserDialogClick() {
            var _this2 = this;

            _axios2.default.all([_user2.default.addUser(this.addUserDialog.form.email, this.addUserDialog.form.role, this.user.activeZone, this.addUserDialog.form.password)]).then(_axios2.default.spread(function (userAddResponse) {
                console.log(userAddResponse);
                if (userAddResponse.data.result != null && userAddResponse.data.result == "success") {
                    var h = _this2.$createElement;
                    _this2.$notify({
                        title: "Add User",
                        message: "Success",
                        type: "info"
                    });
                    _this2.getZoneUsers();
                    _this2.addUserDialog.visible = false;
                }
                if (userAddResponse.data.error != null && userAddResponse.data.error == "User already exists") {
                    var _h = _this2.$createElement;
                    _this2.$notify({
                        title: "Add User",
                        message: "Error - User already exists.  Please use the add existing user option",
                        type: "error"
                    });
                    _this2.addUserDialog.visible = false;
                }
                if (userAddResponse.data.error != null && userAddResponse.data.error == "Password too weak") {
                    var _h2 = _this2.$createElement;
                    _this2.$notify({
                        title: "Add User",
                        message: "Error - Password is too weak.  Passwords needs to be a minimum of 8 characters and includes updercase and numbers",
                        type: "error"
                    });
                }
            }));
        },
        handleRemoveAccessZone: function handleRemoveAccessZone(zoneId) {
            console.log(zoneId);
        },
        userDeleteClick: function userDeleteClick(index, row) {
            this.userDeleteDialog.form.email = row.email;
            this.userDeleteDialog.visible = true;
        },
        userDeleteDialogClick: function userDeleteDialogClick() {
            var _this3 = this;

            _user2.default.deleteUserAccessToZone(this.userDeleteDialog.form.email, this.user.activeZone).then(function (result, err) {
                if (result.data.error != null) {
                    _this3.$notify({
                        title: "Add existing user error",
                        message: result.data.error,
                        type: "info"
                    });
                }
                _this3.userDeleteDialog.visible = false;
                _this3.getZoneUsers();
            });
        },
        userZonesClick: function userZonesClick(index, row) {
            var _this4 = this;

            _axios2.default.all([_user2.default.getUserZoneAccess(row.email)]).then(_axios2.default.spread(function (userZoneAccessResponse) {
                _this4.userZonesDialog.form.zones = userZoneAccessResponse.data;
            }));
            this.userZonesDialog.form.email = row.email;
            this.userZonesDialog.visible = true;
        },
        handleCurrentChange: function handleCurrentChange() {},
        filterUsers: function filterUsers() {
            var _this5 = this;

            if (this.filters.name.length > 0) {
                this.users = this.allUsers.filter(function (user) {
                    return user.email.toLowerCase().includes(_this5.filters.name.toLowerCase());
                });
            } else {
                this.users = this.allUsers;
            }
        },
        getZoneUsers: function getZoneUsers() {
            var _this6 = this;

            this.listLoading = true;
            _axios2.default.all([_user2.default.getZoneUsers(this.user.activeZone)]).then(_axios2.default.spread(function (zoneUsersResponse) {
                _this6.listLoading = false;
                _this6.allUsers = zoneUsersResponse.data;
                _this6.users = zoneUsersResponse.data;
                console.log(zoneUsersResponse);

                _this6.filterUsers();

                _this6.getAllUsers();
            }));
        },
        getAllUsers: function getAllUsers() {
            var _this7 = this;

            this.addExistingUserDialog.users = [];
            _axios2.default.all([_user2.default.getUsers()]).then(_axios2.default.spread(function (usersResponse) {

                usersResponse.data.forEach(function (user) {
                    if (user.role != 'Administrator') {
                        if (_this7.allUsers.filter(function (assignedUser) {
                            return assignedUser.email == user.email;
                        }).length == 0) {
                            _this7.addExistingUserDialog.users.push({
                                value: user.email
                            });
                        }
                    }
                });
            }));
        }
    },
    mounted: function mounted() {
        this.getZoneUsers();
    }
};

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

var _dateformat = __webpack_require__(183);

var _dateformat2 = _interopRequireDefault(_dateformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      columns: {
        panelSerial: false,
        billingDueDate: true
      },
      boro_options: [{
        value: 1,
        label: "Manhattan"
      }, {
        value: 2,
        label: "Queens"
      }],
      filters: {
        name: ""
      },
      zones: [],
      allZones: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      user: this.$session.get("User"),
      zoneDialog: {
        title: "",
        visible: false,
        loading: false,
        showPanelID: false,
        form: {
          name: "",
          deviceID: "",
          zoneID: "",
          boro: "",
          nextBillingAt: ""
        }
      }
    };
  },

  methods: {
    sortBillingMethod: function sortBillingMethod(a, b) {
      console.log(a);
      return a - b;
    },
    zoneEditClick: function zoneEditClick(index, row) {
      this.zoneDialog.title = "Edit Zone";
      this.zoneDialog.form.name = row.name;
      this.zoneDialog.form.deviceID = row.id;
      this.zoneDialog.form.zoneID = row.gsd_id;
      this.zoneDialog.form.boro = row.boro_id;
      this.zoneDialog.form.nextBillingAt = row.nextBillingAt;
      this.zoneDialog.visible = true;
      this.zoneDialog.showPanelID = false;
    },
    zoneDeleteClick: function zoneDeleteClick(index, row) {
      var _this = this;

      this.$confirm("This will permanently delete the Zone. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        _axios2.default.all([_user2.default.deleteZone(row.id)]).then(_axios2.default.spread(function (deleteZoneResponse) {
          if (deleteZoneResponse.data.result == "success") {
            _this.getZones();
            _this.$message({
              type: "success",
              message: "Delete completed"
            });
          } else {
            _this.$message({
              type: "warning",
              message: "Error Deleting Zone"
            });
          }
        }));
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    handleCurrentChange: function handleCurrentChange() {},
    zoneDialogClick: function zoneDialogClick() {
      if (this.zoneDialog.title == "Add Zone") {
        this.addZone();
      } else {
        this.editZone();
      }
    },
    editZone: function editZone() {
      var _this2 = this;

      if (!this.zoneDialog.form.nextBillingAt) {
        var h = this.$createElement;
        this.$notify({
          title: "Update Zone",
          message: "Error Billing At cannot be empty",
          type: "error"
        });
        return;
      }

      this.zoneDialog.loading = true;
      var dateOfNextBilling = new Date(this.zoneDialog.form.nextBillingAt.toLocaleDateString('en-CA') + 'T00:00:00.000Z');
      _axios2.default.all([_user2.default.updateZone(this.zoneDialog.form.deviceID, this.zoneDialog.form.name, this.zoneDialog.form.zoneID, this.zoneDialog.form.boro, dateOfNextBilling)]).then(_axios2.default.spread(function (zoneUpdateResponse) {
        _this2.zoneDialog.loading = false;
        _this2.zoneDialog.visible = false;
        if (zoneUpdateResponse.data.result == "success") {
          var _h = _this2.$createElement;
          _this2.$notify({
            title: "Update Zone",
            message: "Sucess",
            type: "info"
          });
          _this2.getZones();
        } else {
          console.log(zoneUpdateResponse);
          var _h2 = _this2.$createElement;
          _this2.$notify({
            title: "Update Zone",
            message: "Error while updating Zone",
            type: "error"
          });
        }
      }));
    },
    addZone: function addZone() {
      var _this3 = this;

      if (!this.zoneDialog.form.nextBillingAt) {
        var h = this.$createElement;
        this.$notify({
          title: "Update Zone",
          message: "Error Billing At cannot be empty",
          type: "error"
        });
        return;
      }
      this.zoneDialog.loading = true;
      var dateOfNextBilling = new Date(this.zoneDialog.form.nextBillingAt.toLocaleDateString('en-CA') + 'T00:00:00.000Z');
      _axios2.default.all([_user2.default.addZone(this.zoneDialog.form.deviceID, this.zoneDialog.form.name, this.zoneDialog.form.zoneID, this.zoneDialog.form.boro, dateOfNextBilling)]).then(_axios2.default.spread(function (zoneAddResponse) {
        _this3.zoneDialog.loading = false;
        _this3.zoneDialog.visible = false;
        if (zoneAddResponse.data.result == "success") {
          var _h3 = _this3.$createElement;
          _this3.$notify({
            title: "Add Zone",
            message: "Zone Added",
            type: "info"
          });
          _this3.getZones();
        } else {
          var _h4 = _this3.$createElement;
          _this3.$notify({
            title: "Add Zone",
            message: "Error while adding zone",
            type: "error"
          });
        }
      }));
    },
    addZoneClick: function addZoneClick() {
      this.zoneDialog.title = "Add Zone";
      this.zoneDialog.visible = true;
      this.zoneDialog.form.name = "";
      this.zoneDialog.form.deviceID = "";
      this.zoneDialog.form.zoneID = "";
      this.zoneDialog.form.boro = 1;
      this.zoneDialog.showPanelID = true;
    },
    filterZones: function filterZones() {
      var _this4 = this;

      if (this.filters.name.length > 0) {
        this.zones = this.allZones.filter(function (zone) {
          return zone.name.toLowerCase().includes(_this4.filters.name.toLowerCase());
        });
      } else {
        this.zones = this.allZones;
      }
    },
    getZones: function getZones() {
      var _this5 = this;

      this.listLoading = true;
      _axios2.default.all([_user2.default.getZones(this.user.email)]).then(_axios2.default.spread(function (zonesResponse) {
        _this5.listLoading = false;
        _this5.allZones = zonesResponse.data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_this5.allZones), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var zone = _step.value;

            zone.billingDue = false;
            zone.nextBillingAt = "";

            if (zone.next_billing_at) {
              console.log(zone.billing_due);
              zone.nextBillingAt = (0, _dateformat2.default)(zone.next_billing_at, "yyyy-mm-dd");
              zone.billingDue = zone.billing_due == 1;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        console.log(_this5.allZones);

        _this5.filterZones();
      }));
      _axios2.default.all([_user2.default.getBoros()]).then(_axios2.default.spread(function (getBorosResponse) {
        _this5.boro_options = getBorosResponse.data;
      }));
    },
    zoneActivate: function zoneActivate(index, row) {
      var _this6 = this;

      console.log(this.user);
      _user2.default.switchZone(row.id, this.user.email).then(function (response) {
        _user2.default.getUser(_this6.user.email).then(function (response) {
          if (response.data.error == null) {
            _this6.$session.set("User", response.data);
            _this6.$root.$emit("zoneChanged", row.id);
            _this6.$router.push("/Dashboard");
            console.log(row.id);
          }
        });
      });
    }
  },
  mounted: function mounted() {
    this.getZones();
  }
};

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(630);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(218);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(216);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(634);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

var _dateformat = __webpack_require__(183);

var _dateformat2 = _interopRequireDefault(_dateformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    allowManage: function allowManage() {
      return this.user.role == "admin";
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      user: this.$session.get("User"),
      boroOptions: [],
      boroSelection: [],

      columnOptions: [{
        value: 'compensator',
        label: 'Compensator'
      }, {
        value: 'targetPosition',
        label: 'Target Position'
      }, {
        value: 'softwareVersion',
        label: 'Software Version'
      }, {
        value: 'billingDue',
        label: 'Billing Due'
      }, {
        value: 'temperatureReturn',
        label: 'Temperature - Return'
      }, {
        value: 'pressureReturn',
        label: 'Pressure - Return'
      }, {
        value: 'zoneSerialNumber',
        label: 'Zone Serial Number'
      }],
      columnSelection: [],

      columns: {
        compensator: false,
        targetPos: false,
        boro: false,
        zoneID: false,
        softwareVersion: false,
        billingDue: false,
        pressureReturn: false,
        temperatureReturn: false
      },
      polling: null,
      filters: {
        name: ""
      },
      zones: [],
      allzones: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false
    }, (0, _defineProperty3.default)(_ref, "user", this.$session.get("User")), (0, _defineProperty3.default)(_ref, "zoneDialog", {
      title: "",
      visible: false,
      loading: false,
      showPanelID: false,
      form: {
        name: "",
        deviceID: ""
      }
    }), _ref;
  },

  methods: {
    columnsSelectionChanged: function columnsSelectionChanged() {
      console.log("columns selection changed");
      console.log(this.columnSelection);
      this.columns.compensator = this.columnSelection.indexOf('compensator') >= 0;
      this.columns.targetPos = this.columnSelection.indexOf('targetPosition') >= 0;
      this.columns.zoneID = this.columnSelection.indexOf('zoneSerialNumber') >= 0;
      this.columns.softwareVersion = this.columnSelection.indexOf('softwareVersion') >= 0;
      this.columns.billingDue = this.columnSelection.indexOf('billingDue') >= 0;
      this.columns.pressureReturn = this.columnSelection.indexOf('pressureReturn') >= 0;
      this.columns.temperatureReturn = this.columnSelection.indexOf('temperatureReturn') >= 0;
      localStorage.setItem("columnChooserSelection", (0, _stringify2.default)(this.columnSelection));
    },
    editZone: function editZone(value) {
      console.log("edditing");
      console.log(value);
    },
    FilterItems: function FilterItems() {
      var _this = this;

      console.log("here");
      localStorage.setItem("zoneFilter", this.filters.name);
      localStorage.setItem("boroSelection", (0, _stringify2.default)(this.boroSelection));
      if (this.filters.name.length > 0) {
        this.zones = this.allzones.filter(function (zone) {
          return (_this.boroSelection.length == 0 || _this.boroSelection.includes(zone.boro)) && (zone.name.toLowerCase().includes(_this.filters.name.toLowerCase()) || zone.gsd_id.toLowerCase().includes(_this.filters.name.toLowerCase()));
        });
      } else {
        this.zones = this.allzones.filter(function (zone) {
          return _this.boroSelection.length == 0 || _this.boroSelection.includes(zone.boro);
        });
      }
    },
    handleCurrentChange: function handleCurrentChange() {},
    goToManageZones: function goToManageZones() {
      this.$router.push("/Zones");
    },
    zoneActivateClick: function zoneActivateClick(row) {
      var _this2 = this;

      console.log(this.user);
      _user2.default.switchZone(row.id, this.user.email).then(function (response) {
        _user2.default.getUser(_this2.user.email).then(function (response) {
          if (response.data.error == null) {
            _this2.$session.set("User", response.data);
            _this2.$root.$emit("zoneChanged", row.id);
            _this2.$router.push("/Dashboard");
            console.log(row.id);
          }
        });
      });
    },
    getZones: function getZones() {
      var _this3 = this;

      this.listLoading = true;
      _axios2.default.all([_user2.default.getZonesEx(this.user.email)]).then(_axios2.default.spread(function (zonesResponse) {
        _this3.listLoading = false;
        var unique = [].concat((0, _toConsumableArray3.default)(new _set2.default(zonesResponse.data.map(function (item) {
          return item.boro;
        }))));
        _this3.boroOptions = [];
        unique.forEach(function (element) {
          _this3.boroOptions.push({
            value: element,
            label: element
          });
        });
        _this3.allzones = zonesResponse.data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_this3.allzones), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var zone = _step.value;

            console.log(zone);
            zone.billingDue = false;
            zone.nextBillingAt = "";

            if (zone.next_billing_at) {
              console.log(zone.billing_due);
              zone.nextBillingAt = (0, _dateformat2.default)(zone.next_billing_at, "yyyy-mm-dd");
              zone.billingDue = zone.billing_due == 1;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (localStorage.getItem("zoneFilter") && localStorage.getItem("zoneFilter").length > 0) {
          _this3.filters.name = localStorage.getItem("zoneFilter");
        }
        if (localStorage.getItem("columnChooserSelection")) {
          _this3.columnSelection = JSON.parse(localStorage.getItem("columnChooserSelection"));
        }
        if (localStorage.getItem("boroSelection")) {
          _this3.boroSelection = JSON.parse(localStorage.getItem("boroSelection"));
        }
        _this3.FilterItems();
      }));
    }
  },
  mounted: function mounted() {
    this.getZones();
    this.polling = setInterval(this.getZones, 60000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  }
};

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		}
	}
};

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(217);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getCount'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['increment', 'decrement']))
};

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {
                enabled: false,
                setPoint: "",
                feedbackSensitivity: ""
            },
            user: this.$session.get("User")
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        verifySettings: function verifySettings() {
            if (isNaN(parseInt(this.form.feedbackSensitivity)) || parseInt(this.form.feedbackSensitivity) < 0 || parseInt(this.form.feedbackSensitivity) > 100) {
                var h = this.$createElement;
                this.$notify({
                    title: "Feedback Sensitivity",
                    message: "Value not valid.  Value should be between 0 and 100",
                    type: "error"
                });
                return false;
            }
            return true;
        },
        saveDataToPanel: function saveDataToPanel() {
            var _this = this;

            if (!this.verifySettings()) return;
            this.loading = true;
            _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.Enabled", this.form.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.Sensitivity", this.form.feedbackSensitivity), _settings2.default.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.SetPoint", this.form.setPoint)]).then(_axios2.default.spread(function (enabledResponse, feedbackSensitivityResponse, setPointResponse) {
                _this.loading = false;
                if (enabledResponse.data.result != "success" || feedbackSensitivityResponse.data.result != "success" || setPointResponse.data.result != "success") {
                    var h = _this.$createElement;
                    _this.$notify({
                        title: "Apartment Average",
                        message: "Error trying to save data to panel",
                        type: "error"
                    });
                } else {
                    _this.$notify({
                        title: "Apartment Average",
                        message: "Settings Saved to Panel",
                        type: "info"
                    });
                }
            })).catch(function () {
                _this.loading = false;
                var h = _this.$createElement;
                _this.$notify({
                    title: "Heat Balancer",
                    message: "Error trying to save data to panel",
                    type: "error"
                });
            });
        },
        getData: function getData() {
            var _this2 = this;

            _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
                _this2.form.enabled = settingsResponse.data.apartmentAverage.enabled == "true";
                _this2.form.setPoint = settingsResponse.data.apartmentAverage.setpoint;
                _this2.form.feedbackSensitivity = settingsResponse.data.apartmentAverage.sensitivity;
            }));
        }
    }
};

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,

      winterStartStopMonthOptions: [{
        value: 1,
        label: "Jan"
      }, {
        value: 2,
        label: "Feb"
      }, {
        value: 3,
        label: "Mar"
      }, {
        value: 4,
        label: "Apr"
      }, {
        value: 5,
        label: "May"
      }, {
        value: 6,
        label: "Jun"
      }, {
        value: 7,
        label: "Jul"
      }, {
        value: 8,
        label: "Aug"
      }, {
        value: 9,
        label: "Sep"
      }, {
        value: 10,
        label: "Oct"
      }, {
        value: 11,
        label: "Nov"
      }, {
        value: 12,
        label: "Dec"
      }],
      winterStartDayOptions: [],
      winterStopDayOptions: [],

      winterStartMonth: 3,
      winterStartDay: 5,
      winterStopMonth: 6,
      winterStopDay: 7,

      renderWinterStartDaySelect: true,
      renderWinterStopDaySelect: true,

      winterEnabled: false,
      autoHeatAdjustEnabled: false,
      rampUpSpeed: "",
      rampDownSpeed: "",
      heatup: {
        adjustment: "",
        start: "",
        duration: ""
      },
      midday: {
        adjustment: "",
        start: "",
        duration: ""
      },
      night: {
        adjustment: "",
        start: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      timelineItems: [],
      form: {},
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.heatup.adjustment)) || parseInt(this.heatup.adjustment) < 0 || parseInt(this.heatup.adjustment) > 100) {
        var h = this.$createElement;
        this.$notify({
          title: "Heatup Adjustment",
          message: "Value not valid.  Adjustment should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.midday.adjustment)) || parseInt(this.midday.adjustment) < 0 || parseInt(this.midday.adjustment) > 100) {
        var _h = this.$createElement;
        this.$notify({
          title: "Midday Adjustment",
          message: "Value not valid.  Adjustment should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.night.adjustment)) || parseInt(this.night.adjustment) < -100 || parseInt(this.night.adjustment) > 100) {
        var _h2 = this.$createElement;
        this.$notify({
          title: "Night Adjustment",
          message: "Value not valid.  Adjustment should be between -100 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.rampUpSpeed)) || parseInt(this.rampUpSpeed) < 0 || parseInt(this.rampUpSpeed) > 20) {
        var _h3 = this.$createElement;
        this.$notify({
          title: "Ramp Up speed",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.rampDownSpeed)) || parseInt(this.rampDownSpeed) < 0 || parseInt(this.rampDownSpeed) > 20) {
        var _h4 = this.$createElement;
        this.$notify({
          title: "Ramp down speed",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        });
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;

      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Enabled", this.winterEnabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Start.Month", this.winterStartMonth), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Start.Day", this.winterStartDay), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Stop.Month", this.winterStopMonth), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Stop.Day", this.winterStopDay), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Enabled", this.autoHeatAdjustEnabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.RampUp", this.rampUpSpeed), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.RampDown", this.rampDownSpeed), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.Heatup", this.heatup.adjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.MidDay", this.midday.adjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.Night", this.night.adjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Heatup.Start", this.heatup.start), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Heatup.Duration", this.heatup.duration), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Midday.Start", this.midday.start), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Midday.Duration", this.midday.duration), _settings2.default.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Night.Start", this.night.start)]).then(_axios2.default.spread(function (winterEnabledResponse, winterStartMonthResponse, winterStartDayResponse, winterStopMonthResponse, winterStopDayResponse, ahaEnabledResponse, ahaRampUpSpeedResponse, ahaRampDownSpeedResponse, heatupAdjustmentResponse, middayAdjustmentResponse, nightAdjustmentResponse, heatupStartResponse, heatupDurationResponse, middayStartResponse, middayDurationResponse, nightStartResponse) {
        _this.loading = false;
        if (winterEnabledResponse.data.result != "success" || winterStartMonthResponse.data.result != "success" || winterStartDayResponse.data.result != "success" || winterStopMonthResponse.data.result != "success" || winterStopDayResponse.data.result != "success" || ahaEnabledResponse.data.result != "success" || ahaRampUpSpeedResponse.data.result != "success" || ahaRampDownSpeedResponse.data.result != "success" || heatupAdjustmentResponse.data.result != "success" || middayAdjustmentResponse.data.result != "success" || nightAdjustmentResponse.data.result != "success" || heatupStartResponse.data.result != "success" || heatupDurationResponse.data.result != "success" || middayStartResponse.data.result != "success" || middayDurationResponse.data.result != "success" || nightStartResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Auto Heat",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Auto Heat",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Auto Heat",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    generateTimeline: function generateTimeline() {
      this.timelineItems = [{
        tag: this.heatup.start,
        content: "Heatup (Duration - " + this.heatup.duration + ")"
      }, {
        tag: this.midday.start,
        content: "Midday (Duration - " + this.midday.duration + ")"
      }, {
        tag: this.night.start,
        content: "Night"
      }];
    },
    getMonthFromString: function getMonthFromString(mon) {
      return new Date(Date.parse(mon + " 1, 2012")).getMonth() + 1;
    },
    HeatUpStartChange: function HeatUpStartChange(data) {
      this.generateTimeline();
    },
    HeatUpDurationChange: function HeatUpDurationChange(data) {
      this.generateTimeline();
    },
    MiddayStartChange: function MiddayStartChange(data) {
      this.generateTimeline();
    },
    MiddayDurationChange: function MiddayDurationChange(data) {
      this.generateTimeline();
    },
    NightStartChange: function NightStartChange(data) {
      this.generateTimeline();
    },
    winterStartMonthChanged: function winterStartMonthChanged() {
      this.updateWinterStartDayOptions();
    },
    winterStartDayChanged: function winterStartDayChanged() {},
    winterStopMonthChanged: function winterStopMonthChanged() {
      this.updateWinterStopDayOptions();
    },
    winterStopDayChanged: function winterStopDayChanged() {},
    updateWinterStartDayOptions: function updateWinterStartDayOptions() {
      var _this2 = this;

      this.winterStartDayOptions = [];
      var daysInMonth = 30;
      switch (this.winterStartMonth) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          daysInMonth = 31;
          break;
        case 2:
          daysInMonth = 28;
          if (this.winterStartDay > 28) this.winterStartDay = 28;
          break;
        default:
          daysInMonth = 30;
          if (this.winterStartDay > 30) this.winterStartDay = 30;
          break;
      }
      for (var day = 1; day <= daysInMonth; day++) {
        this.winterStartDayOptions.push({
          value: day,
          label: day
        });
      }
      this.renderWinterStartDaySelect = false;
      this.$nextTick(function () {
        _this2.renderWinterStartDaySelect = true;
      });
    },
    updateWinterStopDayOptions: function updateWinterStopDayOptions() {
      var _this3 = this;

      this.winterStopDayOptions = [];
      var daysInMonth = 30;
      switch (this.winterStopMonth) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          daysInMonth = 31;
          break;
        case 2:
          daysInMonth = 28;
          if (this.winterStopDay > 28) this.winterStopDay = 28;
          break;
        default:
          daysInMonth = 30;
          if (this.winterStopDay > 30) this.winterStopDay = 30;
          break;
      }
      for (var day = 1; day <= daysInMonth; day++) {
        this.winterStopDayOptions.push({
          value: day,
          label: day
        });
      }
      this.renderWinterStopDaySelect = false;
      this.$nextTick(function () {
        _this3.renderWinterStopDaySelect = true;
      });
    },
    getData: function getData() {
      var _this4 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        console.log(settingsResponse);
        _this4.winterEnabled = settingsResponse.data.AHA.winter.enabled == "true";

        _this4.winterStartMonth = settingsResponse.data.AHA.winter.start.month;
        _this4.winterStartDay = settingsResponse.data.AHA.winter.start.day;
        _this4.winterStopMonth = settingsResponse.data.AHA.winter.stop.month;
        _this4.winterStopDay = settingsResponse.data.AHA.winter.stop.day;
        _this4.updateWinterStartDayOptions();
        _this4.updateWinterStopDayOptions();

        _this4.autoHeatAdjustEnabled = settingsResponse.data.AHA.enabled == "true";

        _this4.autoHeatAdjustEnabled = settingsResponse.data.AHA.enabled == "true";
        _this4.rampUpSpeed = settingsResponse.data.AHA.rampUp;
        _this4.rampDownSpeed = settingsResponse.data.AHA.rampDown;

        _this4.heatup.adjustment = settingsResponse.data.AHA.adjustment.heatup;
        _this4.midday.adjustment = settingsResponse.data.AHA.adjustment.midday;
        _this4.night.adjustment = settingsResponse.data.AHA.adjustment.night;

        _this4.heatup.start = settingsResponse.data.AHA.timer.heatup.start;
        _this4.heatup.duration = settingsResponse.data.AHA.timer.heatup.duration;

        _this4.midday.start = settingsResponse.data.AHA.timer.midday.start;
        _this4.midday.duration = settingsResponse.data.AHA.timer.midday.duration;

        _this4.night.start = settingsResponse.data.AHA.timer.night.start;
        _this4.generateTimeline();
      }));
    }
  }
};

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        enabled: false,
        sensitivity: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.sensitivity)) || parseInt(this.form.sensitivity) < 0 || parseInt(this.form.sensitivity) > 100) {
        var h = this.$createElement;
        this.$notify({
          title: "Sensitivity",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Compensator.Sensitivity", this.form.sensitivity)]).then(_axios2.default.spread(function (sensitivityResponse) {
        _this.loading = false;
        if (sensitivityResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Compensator",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Compensator",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Compensator",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.sensitivity = settingsResponse.data.compensator.sensitivity;
      }));
    }
  }
};

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        enabled: false,
        setPoint: "",
        deadband: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.setPoint)) || parseInt(this.form.setPoint) < 0 || parseInt(this.form.setPoint) > 50) {
        var h = this.$createElement;
        this.$notify({
          title: "Setpoint",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.deadband)) || parseInt(this.form.deadband) < 0 || parseInt(this.form.deadband) > 50) {
        var _h = this.$createElement;
        this.$notify({
          title: "Deadband",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        });
        return false;
      }
      return true;
    },
    roundHalf: function roundHalf(num) {
      return Math.round(num * 2) / 2;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return true;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Differential.Enabled", this.form.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Differential.Setpoint", this.roundHalf(parseFloat(this.form.setPoint)) / 2.036), _settings2.default.changeSetting(this.user.activeZone, "Settings.Differential.Deadband", this.roundHalf(parseFloat(this.form.deadband)) / 2.036)]).then(_axios2.default.spread(function (enabledResponse, setPointResponse, deadbandResponse) {
        _this.loading = false;
        if (enabledResponse.data.result != "success" || setPointResponse.data.result != "success" || deadbandResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Differential",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Differential",
            message: "Settings Saved to Panel",
            type: "info"
          });
          _this.getData();
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Differential",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.enabled = settingsResponse.data.differential.enabled == "true";
        _this2.form.setPoint = (parseFloat(settingsResponse.data.differential.setpoint) * 2.036).toFixed(1);
        _this2.form.deadband = (parseFloat(settingsResponse.data.differential.deadband) * 2.036).toFixed(1);
      }));
    }
  }
};

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      dayNightSelector: "Day",
      chart: {
        Xstart: 80,
        Xstop: 0,
        xAxis: [],
        xAxisPoints: 20
      },
      chartLine: null,
      form: {
        mildWeatherDay: "",
        mildWeatherNight: "",
        valveFeedbackSensitivity: "",
        exponentialCurve: "",
        exponentialSensitivity: "",
        integralPeriod: "",
        integralSetpoint: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      linearData: [],
      exponentialData: [],
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
    for (var i = this.chart.Xstop; i <= this.chart.xAxisPoints; i++) {
      this.chart.xAxis.push((i * (this.chart.Xstart / this.chart.xAxisPoints)).toFixed(0) + "°F");
    }
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.mildWeatherDay)) || parseInt(this.form.mildWeatherDay) < -20 || parseInt(this.form.mildWeatherDay) > 100) {
        var h = this.$createElement;
        this.$notify({
          title: "Mild Weather Day",
          message: "Value not valid.  Value should be between -20 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.mildWeatherNight)) || parseInt(this.form.mildWeatherNight) < -20 || parseInt(this.form.mildWeatherNight) > 100) {
        var _h = this.$createElement;
        this.$notify({
          title: "Mild Weather Night",
          message: "Value not valid.  Value should be between -20 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.valveFeedbackSensitivity)) || parseInt(this.form.valveFeedbackSensitivity) < 1 || parseInt(this.form.valveFeedbackSensitivity) > 50) {
        var _h2 = this.$createElement;
        this.$notify({
          title: "Valve Feedback Sensitivity",
          message: "Value not valid.  Value should be between 1 and 50",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.exponentialCurve)) || parseInt(this.form.exponentialCurve) < -100 || parseInt(this.form.exponentialCurve) > 100) {
        var _h3 = this.$createElement;
        this.$notify({
          title: "Exponential Curve",
          message: "Value not valid.  Value should be between -100 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.exponentialSensitivity)) || parseInt(this.form.exponentialSensitivity) < 0 || parseInt(this.form.exponentialSensitivity) > 100) {
        var _h4 = this.$createElement;
        this.$notify({
          title: "Exponential Sensitivity",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.integralPeriod)) || parseInt(this.form.integralPeriod) < 1 || parseInt(this.form.integralPeriod) > 60) {
        var _h5 = this.$createElement;
        this.$notify({
          title: "Integral Period",
          message: "Value not valid.  Value should be between 1 and 60",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.integralSetpoint)) || parseInt(this.form.integralSetpoint) < 0 || parseInt(this.form.integralSetpoint) > 100) {
        var _h6 = this.$createElement;
        this.$notify({
          title: "Integral Setpoint",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.MildWeatherDay", this.form.mildWeatherDay), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.MildWeatherNight", this.form.mildWeatherNight), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.ValveFeedbackSensitivity", this.form.valveFeedbackSensitivity), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.Curve.Exponential", this.form.exponentialCurve), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.Curve.Sensitivity", this.form.exponentialSensitivity), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.Integral.Period", this.form.integralPeriod), _settings2.default.changeSetting(this.user.activeZone, "Settings.Basic.Integral.Setpoint", this.form.integralSetpoint)]).then(_axios2.default.spread(function (mildWeatherDayResponse, mildWeatherNightResponse, valveFeedbackSensitivityResponse, exponentialCurveResponse, exponentialSensitivityResponse, integralPeriodResponse, integralSetpointResponse) {
        _this.loading = false;
        if (mildWeatherDayResponse.data.result != "success" || mildWeatherNightResponse.data.result != "success" || valveFeedbackSensitivityResponse.data.result != "success" || exponentialCurveResponse.data.result != "success" || exponentialSensitivityResponse.data.result != "success" || integralSetpointResponse.data.result != "success" || integralPeriodResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Heat Settings",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Heat Settings",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Heat Settings",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    valueChanged: function valueChanged() {
      this.generateLinearData();
      this.drawLineChart();
    },
    generateLinearData: function generateLinearData() {
      this.linearData = [];
      this.exponentialData = [];
      var peakFound = false;
      var previousCorrection = 0;
      var peakCorrection = 0;
      for (var i = this.chart.Xstop; i <= this.chart.xAxisPoints; i++) {
        var outdoorTemperature = i * (this.chart.Xstart / this.chart.xAxisPoints);
        var subtractor = this.form.mildWeatherDay;
        if (this.dayNightSelector == "Night") subtractor = this.form.mildWeatherNight;
        var demand = subtractor - outdoorTemperature;
        if (demand < 0) demand = 0;
        var valveFeedbackSensitivity = this.form.valveFeedbackSensitivity / 10.0;
        var linearOutput = valveFeedbackSensitivity * demand;
        var exponentialCurve = this.form.exponentialSensitivity;
        var exponentialDemand = demand - exponentialCurve;
        if (exponentialDemand < 0) exponentialDemand = 0;
        var exponentialCorrection = exponentialDemand * exponentialDemand * (this.form.exponentialCurve / 1000);

        var exponentialOutput = (linearOutput - exponentialCorrection).toFixed(1);

        if (linearOutput > 100) linearOutput = 100;
        if (exponentialOutput > 100) exponentialOutput = 100;
        this.linearData.push(linearOutput.toFixed(1));

        this.exponentialData.push(exponentialOutput);
      }

      exponentialOutput = this.exponentialData[this.exponentialData.length - 1];
      for (var _i = this.exponentialData.length - 2; _i >= 0; _i--) {
        if (parseFloat(this.exponentialData[_i]) < parseFloat(exponentialOutput)) {
          this.exponentialData[_i] = exponentialOutput;
          console.log("f");
        }

        exponentialOutput = this.exponentialData[_i];
      }
    },
    dayNightSelectorChange: function dayNightSelectorChange() {
      this.generateLinearData();
      this.drawLineChart();
    },
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    drawLineChart: function drawLineChart() {
      this.chartLine = _echarts2.default.init(document.getElementById("chartLine"));
      this.chartLine.setOption({
        title: {
          text: "Motor estimated output"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["Linear Control", "Linear & Exponential Combined"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart.xAxis
        },
        yAxis: {
          type: "value",
          name: "Motor Output (%)"
        },
        series: [{
          name: "Linear Control",
          type: "line",
          data: this.linearData
        }, {
          name: "Linear & Exponential Combined",
          type: "line",
          data: this.exponentialData
        }]
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (SettingsResponse) {
        console.log(SettingsResponse.data);
        _this2.form.mildWeatherDay = SettingsResponse.data.basic.mildWeatherDay;
        _this2.form.mildWeatherNight = SettingsResponse.data.basic.mildWeatherNight;
        _this2.form.valveFeedbackSensitivity = SettingsResponse.data.basic.valveFeedbackSensitivity;
        _this2.form.exponentialCurve = SettingsResponse.data.basic.curve.exponential;
        _this2.form.exponentialSensitivity = SettingsResponse.data.basic.curve.sensitivity;
        _this2.form.integralPeriod = SettingsResponse.data.basic.integral.period;
        _this2.form.integralSetpoint = SettingsResponse.data.basic.integral.setpoint;
        _this2.generateLinearData();
        _this2.drawLineChart();
      }));
    }
  }
};

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        enabled: false,
        feedbackSensitivity: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.feedbackSensitivity)) || parseInt(this.form.feedbackSensitivity) < 0 || parseInt(this.form.feedbackSensitivity) > 100) {
        var h = this.$createElement;
        this.$notify({
          title: "Feedback Sensitivity",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.HeatBalancer.Enabled", this.form.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.HeatBalancer.FeedbackSensitivity", this.form.feedbackSensitivity)]).then(_axios2.default.spread(function (enabledResponse, feedbackSensitivityResponse) {
        _this.loading = false;
        if (enabledResponse.data.result != "success" || feedbackSensitivityResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Heat Balancer",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Heat Balancer",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Heat Balancer",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.enabled = settingsResponse.data.heatBalancer.enabled == "true";
        _this2.form.feedbackSensitivity = settingsResponse.data.heatBalancer.feedbackSensitivity;
      }));
    }
  }
};

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        lowLimit: "",
        highLimit: "",
        valveSetSpeed: "",
        lowPressureClose: {
          enabled: false,
          setPoint: ""
        }
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.lowLimit)) || parseInt(this.form.lowLimit) < 0 || parseInt(this.form.lowLimit) > 100) {
        var h = this.$createElement;
        this.$notify({
          title: "Low Limit",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.highLimit)) || parseInt(this.form.highLimit) < 0 || parseInt(this.form.highLimit) > 100) {
        var _h = this.$createElement;
        this.$notify({
          title: "High Limit",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.valveSetSpeed)) || parseInt(this.form.valveSetSpeed) < 0 || parseInt(this.form.valveSetSpeed) > 10) {
        var _h2 = this.$createElement;
        this.$notify({
          title: "Valve Set Speed",
          message: "Value not valid.  Value should be between 0 and 10",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.lowPressureClose.setPoint)) || parseInt(this.form.lowPressureClose.setPoint) < 0 || parseInt(this.form.lowPressureClose.setPoint) > 20) {
        var _h3 = this.$createElement;
        this.$notify({
          title: "Low Pressure Close",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        });
        return false;
      }

      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Motor.Limit.Low", this.form.lowLimit), _settings2.default.changeSetting(this.user.activeZone, "Settings.Motor.Limit.High", this.form.highLimit), _settings2.default.changeSetting(this.user.activeZone, "Settings.Motor.Speed.ValveSet", this.form.valveSetSpeed), _settings2.default.changeSetting(this.user.activeZone, "Settings.Motor.LowPressureClose.Enabled", this.form.lowPressureClose.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Motor.LowPressureClose.SetPoint", this.form.lowPressureClose.setPoint)]).then(_axios2.default.spread(function (lowLimitResponse, highLimitResponse, valveSetSpeedResponse) {
        _this.loading = false;
        if (lowLimitResponse.data.result != "success" || highLimitResponse.data.result != "success" || valveSetSpeedResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Valve Settings",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Valve",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Motor Settings",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.lowLimit = settingsResponse.data.motor.limit.low;
        _this2.form.highLimit = settingsResponse.data.motor.limit.high;
        _this2.form.valveSetSpeed = settingsResponse.data.motor.speed.valveSet;
        _this2.form.lowPressureClose.enabled = settingsResponse.data.motor.lowPressureClose.enabled == "true";
        _this2.form.lowPressureClose.setPoint = settingsResponse.data.motor.lowPressureClose.setPoint;
      }));
    }
  }
};

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        serialNumber: '',
        ipAddress: '',
        netMask: '',
        macAddress: '',
        internetConnection: false,
        cloudServerConnection: false
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    setInterval(this.getData, 1000);
  },

  methods: {
    getData: function getData() {
      var _this = this;

      _axios2.default.all([_settings2.default.getNetworkSettings()]).then(_axios2.default.spread(function (networkSettingsResponse) {
        _this.form.serialNumber = networkSettingsResponse.data.id;
        _this.form.ipAddress = networkSettingsResponse.data.network.eth0[0].address;
        _this.form.netMask = networkSettingsResponse.data.network.eth0[0].netmask;
        _this.form.macAddress = networkSettingsResponse.data.network.eth0[0].mac;
        _this.form.internetConnection = networkSettingsResponse.data.internetConnected;
        _this.form.cloudServerConnection = networkSettingsResponse.data.rabbitServerConnected;
      }));
    }
  }
};

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

var _util = __webpack_require__(163);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      polling: null,
      user: this.$session.get("User"),
      activeName: "boiler",
      boilerForm: {
        currentPressure: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      supplyForm: {
        currentPressure: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      returnForm: {
        currentPressure: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getIOData();
    this.polling = setInterval(this.getIOData, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.boilerForm.calibrationAdjustment)) || isNaN(parseInt(this.boilerForm.rangeHigh)) || isNaN(parseInt(this.boilerForm.rangeLow))) {
        this.notify("Boiler Pressure");
        return false;
      }
      if (isNaN(parseInt(this.supplyForm.calibrationAdjustment)) || isNaN(parseInt(this.supplyForm.rangeHigh)) || isNaN(parseInt(this.supplyForm.rangeLow))) {
        this.notify("Boiler Pressure");
        return false;
      }
      if (isNaN(parseInt(this.returnForm.calibrationAdjustment)) || isNaN(parseInt(this.returnForm.rangeHigh)) || isNaN(parseInt(this.returnForm.rangeLow))) {
        this.notify("Boiler Pressure");
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      switch (this.activeName) {
        case "boiler":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.Enabled", this.boilerForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.CalibrationAdjustment", this.boilerForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.RangeHigh", this.boilerForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.RangeLow", this.boilerForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Boiler Pressure Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Boiler Pressure Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Boiler Pressure Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "supply":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.Enabled", this.supplyForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.CalibrationAdjustment", this.supplyForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.RangeHigh", this.supplyForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.RangeLow", this.supplyForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Supply Pressure Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Supply Pressure Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Supply Pressure Sensor Settings",
              message: "Error trying to save data to Supply",
              type: "error"
            });
          });
          break;
        case "return":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.Enabled", this.returnForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.CalibrationAdjustment", this.returnForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.RangeHigh", this.returnForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.RangeLow", this.returnForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Return Pressure Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Return Pressure Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Return Pressure Sensor Settings",
              message: "Error trying to save data to Supply",
              type: "error"
            });
          });
          break;
      }
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.boilerForm.enabled = settingsResponse.data.sensors.pressure.boiler.enabled == "true";
        _this2.boilerForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.boiler.calibrationAdjustment;
        _this2.boilerForm.rangeHigh = settingsResponse.data.sensors.pressure.boiler.rangeHigh;
        _this2.boilerForm.rangeLow = settingsResponse.data.sensors.pressure.boiler.rangeLow;

        _this2.supplyForm.enabled = settingsResponse.data.sensors.pressure.supply.enabled == "true";
        _this2.supplyForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.supply.calibrationAdjustment;
        _this2.supplyForm.rangeHigh = settingsResponse.data.sensors.pressure.supply.rangeHigh;
        _this2.supplyForm.rangeLow = settingsResponse.data.sensors.pressure.supply.rangeLow;

        _this2.returnForm.enabled = settingsResponse.data.sensors.pressure.return.enabled == "true";
        _this2.returnForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.return.calibrationAdjustment;
        _this2.returnForm.rangeHigh = settingsResponse.data.sensors.pressure.return.rangeHigh;
        _this2.returnForm.rangeLow = settingsResponse.data.sensors.pressure.return.rangeLow;

        if (settingsResponse.data.differential.enabled == "true") {
          _this2.supplyForm.allowControlEnabled = true;
          _this2.returnForm.allowControlEnabled = true;
        }
      }));
    },
    getIOData: function getIOData() {
      var _this3 = this;

      _axios2.default.all([_io2.default.getIO(this.user.activeZone)]).then(_axios2.default.spread(function (IOResponse) {
        _this3.boilerForm.currentPressure = _util2.default.printPressure(IOResponse.data.sensors.pressure.boiler);
        _this3.supplyForm.currentPressure = _util2.default.printPressure(IOResponse.data.sensors.pressure.supply);
        _this3.returnForm.currentPressure = _util2.default.printPressure(IOResponse.data.sensors.pressure.return);
      }));
    }
  }
};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(216);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(90);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        enabled: false,
        targetPosition: ["10", 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.form.targetPosition), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          if (isNaN(parseInt(element)) || parseInt(element) < 0 || parseInt(element) > 100) {
            var h = this.$createElement;
            this.$notify({
              title: "Setpoint",
              message: "Value not valid.  Value should be between 0 and 100",
              type: "error"
            });
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    formatArrayForPanel: function formatArrayForPanel(arrayToFormat) {
      var arrayForPanel = arrayToFormat;
      for (var idx = 0; idx < arrayForPanel.length; idx++) {
        arrayForPanel[idx] = arrayForPanel[idx] + "";
      }
      return arrayForPanel;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return true;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.ProgramMode.Value", (0, _stringify2.default)(this.formatArrayForPanel(this.form.targetPosition)))]).then(_axios2.default.spread(function (valueResponse) {
        _this.loading = false;
        if (valueResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Program Mode",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Program Mode",
            message: "Settings Saved to Panel",
            type: "info"
          });
          _this.getData();
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Program Mode",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        console.log(settingsResponse.data);

        _this2.form.targetPosition = settingsResponse.data.programMode.value;
      }));
    }
  }
};

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        enabled: false,
        setPoint: "",
        deadband: "",
        valveAdjustment: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.form.setPoint)) || parseInt(this.form.setPoint) < 0 || parseInt(this.form.setPoint) > 220) {
        var h = this.$createElement;
        this.$notify({
          title: "Setpoint",
          message: "Value not valid.  Value should be between 0 and 220",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.deadband)) || parseInt(this.form.deadband) < 0 || parseInt(this.form.deadband) > 50) {
        var _h = this.$createElement;
        this.$notify({
          title: "Deadband",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        });
        return false;
      }
      if (isNaN(parseInt(this.form.valveAdjustment)) || parseInt(this.form.valveAdjustment) < 0 || parseInt(this.form.valveAdjustment) > 100) {
        var _h2 = this.$createElement;
        this.$notify({
          title: "Valve Adjustment",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        });
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.ReturnLine.Enabled", this.form.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.ReturnLine.Setpoint", this.form.setPoint), _settings2.default.changeSetting(this.user.activeZone, "Settings.ReturnLine.Adjustment", this.form.valveAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.ReturnLine.Deadband", this.form.deadband)]).then(_axios2.default.spread(function (enabledResponse, setPointResponse, valveAdjustmentResponse, deadbandResponse) {
        _this.loading = false;
        if (enabledResponse.data.result != "success" || setPointResponse.data.result != "success" || valveAdjustmentResponse.data.result != "success" || deadbandResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Return Line",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Return Line",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Return Line",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.enabled = settingsResponse.data.returnLine.enabled == "true";
        _this2.form.setPoint = settingsResponse.data.returnLine.setpoint;
        _this2.form.deadband = settingsResponse.data.returnLine.deadband;
        _this2.form.valveAdjustment = settingsResponse.data.returnLine.adjustment;
      }));
    }
  }
};

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      form: {
        zoneId: "",
        softwareVersion: "",
        bacnetEnabled: false
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      this.loading = true;
      _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.System.Bacnet.Enabled", this.form.bacnetEnabled ? "true" : "false")]).then(_axios2.default.spread(function (bacnetEnabledResponse) {
        _this.loading = false;
        if (bacnetEnabledResponse.data.result != "success") {
          var h = _this.$createElement;
          _this.$notify({
            title: "Bacnet Enable/Disable",
            message: "Error trying to save data to panel",
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Bacnet Enable/Disable",
            message: "Settings Saved to Panel",
            type: "info"
          });
        }
      })).catch(function () {
        _this.loading = false;
        var h = _this.$createElement;
        _this.$notify({
          title: "Bacnet Enable/Disable",
          message: "Error trying to save data to panel",
          type: "error"
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.form.zoneId = _this2.user.activeZone;
        _this2.form.softwareVersion = settingsResponse.data.system.softwareVersion == null ? "" : settingsResponse.data.system.softwareVersion;
        _this2.form.bacnetEnabled = settingsResponse.data.system.bacnet.enabled == 'true';
      }));
    }
  }
};

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _echarts = __webpack_require__(31);

var _echarts2 = _interopRequireDefault(_echarts);

var _io = __webpack_require__(33);

var _io2 = _interopRequireDefault(_io);

var _settings = __webpack_require__(34);

var _settings2 = _interopRequireDefault(_settings);

var _system = __webpack_require__(41);

var _system2 = _interopRequireDefault(_system);

var _util = __webpack_require__(163);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      polling: null,
      loading: false,
      activeName: "outdoor",
      heatBalancerActiveName: "top",
      outdoorForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      domesticForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      stackForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      returnLineForm: {
        currentTemperature: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      auxiliaryForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      heatBalancerForm: {
        enabled: false,
        allowControlEnabled: false,
        difference: "",
        top: {
          currentTemperature: "",
          calibrationAdjustment: "",
          rangeHigh: "",
          rangeLow: ""
        },
        bottom: {
          currentTemperature: "",
          calibrationAdjustment: "",
          rangeHigh: "",
          rangeLow: ""
        }
      },
      user: this.$session.get("User")
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getIOData();
    this.polling = setInterval(this.getIOData, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  },

  methods: {
    notify: function notify(title) {
      var h = this.$createElement;
      this.$notify({
        title: title,
        message: "Value not valid",
        type: "error"
      });
    },
    verifySettings: function verifySettings() {
      if (isNaN(parseInt(this.outdoorForm.calibrationAdjustment)) || isNaN(parseInt(this.outdoorForm.rangeHigh)) || isNaN(parseInt(this.outdoorForm.rangeLow))) {
        this.notify("Outdoor Temperature");
        return false;
      }
      if (isNaN(parseInt(this.domesticForm.calibrationAdjustment)) || isNaN(parseInt(this.domesticForm.rangeHigh)) || isNaN(parseInt(this.domesticForm.rangeLow))) {
        this.notify("Domestic Temperature");
        return false;
      }
      if (isNaN(parseInt(this.stackForm.calibrationAdjustment)) || isNaN(parseInt(this.stackForm.rangeHigh)) || isNaN(parseInt(this.stackForm.rangeLow))) {
        this.notify("Stack Temperature");
        return false;
      }
      if (isNaN(parseInt(this.returnLineForm.calibrationAdjustment)) || isNaN(parseInt(this.returnLineForm.rangeHigh)) || isNaN(parseInt(this.returnLineForm.rangeLow))) {
        this.notify("Retrun line Temperature");
        return false;
      }
      if (isNaN(parseInt(this.auxiliaryForm.calibrationAdjustment)) || isNaN(parseInt(this.auxiliaryForm.rangeHigh)) || isNaN(parseInt(this.auxiliaryForm.rangeLow))) {
        this.notify("Aux Temperature");
        return false;
      }
      if (isNaN(parseInt(this.heatBalancerForm.top.calibrationAdjustment)) || isNaN(parseInt(this.heatBalancerForm.top.rangeHigh)) || isNaN(parseInt(this.heatBalancerForm.top.rangeLow))) {
        this.notify("Heat Balancer Top Temperature");
        return false;
      }
      if (isNaN(parseInt(this.heatBalancerForm.bottom.calibrationAdjustment)) || isNaN(parseInt(this.heatBalancerForm.bottom.rangeHigh)) || isNaN(parseInt(this.heatBalancerForm.bottom.rangeLow))) {
        this.notify("Heat Balancer Bottom Temperature");
        return false;
      }
      return true;
    },
    saveDataToPanel: function saveDataToPanel() {
      var _this = this;

      if (!this.verifySettings()) return;
      switch (this.activeName) {
        case "outdoor":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.CalibrationAdjustment", this.outdoorForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.RangeHigh", this.outdoorForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.RangeLow", this.outdoorForm.rangeLow)]).then(_axios2.default.spread(function (calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Outdoor Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Outdoor Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Outdoor Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "domesticWater":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.Enabled", this.domesticForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.CalibrationAdjustment", this.domesticForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.RangeHigh", this.domesticForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.RangeLow", this.domesticForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Domestic Water Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Domestic Water Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Domestic Water Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "stack":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.Enabled", this.stackForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.CalibrationAdjustment", this.stackForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.RangeHigh", this.stackForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.RangeLow", this.stackForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Stack Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Stack Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Stack Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "returnLine":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.Enabled", this.returnLineForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.CalibrationAdjustment", this.returnLineForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.RangeHigh", this.returnLineForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.RangeLow", this.returnLineForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Return Line Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Return Line Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Return Line Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "aux":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.Enabled", this.auxiliaryForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.CalibrationAdjustment", this.auxiliaryForm.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.RangeHigh", this.auxiliaryForm.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.RangeLow", this.auxiliaryForm.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Aux Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Aux Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Aux Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
        case "heatBalancer":
          this.loading = true;
          _axios2.default.all([_settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Enabled", this.heatBalancerForm.enabled ? "true" : "false"), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.CalibrationAdjustment", this.heatBalancerForm.top.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.RangeHigh", this.heatBalancerForm.top.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.RangeLow", this.heatBalancerForm.top.rangeLow), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.CalibrationAdjustment", this.heatBalancerForm.bottom.calibrationAdjustment), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.RangeHigh", this.heatBalancerForm.bottom.rangeHigh), _settings2.default.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.RangeLow", this.heatBalancerForm.bottom.rangeLow)]).then(_axios2.default.spread(function (enabledResponse, topCalibrationResponse, topRangeHighResponse, topRangeLowResponse, bottomCalibrationResponse, bottomRangeHighResponse, bottomRangeLowResponse) {
            _this.loading = false;
            if (enabledResponse.data.result != "success" || topCalibrationResponse.data.result != "success" || topRangeHighResponse.data.result != "success" || topRangeLowResponse.data.result != "success" || bottomCalibrationResponse.data.result != "success" || bottomRangeHighResponse.data.result != "success" || bottomRangeLowResponse.data.result != "success") {
              var h = _this.$createElement;
              _this.$notify({
                title: "Heat Balancer Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              });
            } else {
              _this.$notify({
                title: "Heat Balancer Temperature Sensor Settings",
                message: "Settings Saved to Panel",
                type: "info"
              });
            }
          })).catch(function () {
            _this.loading = false;
            var h = _this.$createElement;
            _this.$notify({
              title: "Heat Balancer Temperature Sensor Settings",
              message: "Error trying to save data to panel",
              type: "error"
            });
          });
          break;
      }
    },
    showNotification: function showNotification(data, _title, value, min, max) {
      if (data < min || data > max || data == "") {
        var h = this.$createElement;
        this.$notify({
          title: _title,
          message: value + " should be betweeen " + min + " and " + max,
          type: "warning"
        });
        return false;
      } else {
        return true;
      }
    },
    getData: function getData() {
      var _this2 = this;

      _axios2.default.all([_io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (settingsResponse) {
        _this2.outdoorForm.enabled = settingsResponse.data.sensors.temperature.outdoor.enabled == "true";
        _this2.outdoorForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.outdoor.calibrationAdjustment;
        _this2.outdoorForm.rangeHigh = settingsResponse.data.sensors.temperature.outdoor.rangeHigh;
        _this2.outdoorForm.rangeLow = settingsResponse.data.sensors.temperature.outdoor.rangeLow;

        _this2.domesticForm.enabled = settingsResponse.data.sensors.temperature.domesticWater.enabled == "true";
        _this2.domesticForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.domesticWater.calibrationAdjustment;
        _this2.domesticForm.rangeHigh = settingsResponse.data.sensors.temperature.domesticWater.rangeHigh;
        _this2.domesticForm.rangeLow = settingsResponse.data.sensors.temperature.domesticWater.rangeLow;

        _this2.stackForm.enabled = settingsResponse.data.sensors.temperature.stack.enabled == "true";
        _this2.stackForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.stack.calibrationAdjustment;
        _this2.stackForm.rangeHigh = settingsResponse.data.sensors.temperature.stack.rangeHigh;
        _this2.stackForm.rangeLow = settingsResponse.data.sensors.temperature.stack.rangeLow;

        _this2.returnLineForm.enabled = settingsResponse.data.sensors.temperature.returnLine.enabled == "true";

        if (settingsResponse.data.returnLine.enabled == "true") {
          _this2.returnLineForm.allowControlEnabled = true;
        }

        _this2.returnLineForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.returnLine.calibrationAdjustment;
        _this2.returnLineForm.rangeHigh = settingsResponse.data.sensors.temperature.returnLine.rangeHigh;
        _this2.returnLineForm.rangeLow = settingsResponse.data.sensors.temperature.returnLine.rangeLow;

        _this2.auxiliaryForm.enabled = settingsResponse.data.sensors.temperature.aux.enabled == "true";
        _this2.auxiliaryForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.aux.calibrationAdjustment;
        _this2.auxiliaryForm.rangeHigh = settingsResponse.data.sensors.temperature.aux.rangeHigh;
        _this2.auxiliaryForm.rangeLow = settingsResponse.data.sensors.temperature.aux.rangeLow;

        _this2.heatBalancerForm.enabled = settingsResponse.data.sensors.temperature.heatBalancer.enabled == "true";
        if (settingsResponse.data.heatBalancer.enabled == "true") _this2.heatBalancerForm.allowControlEnabled = true;

        _this2.heatBalancerForm.top.calibrationAdjustment = settingsResponse.data.sensors.temperature.heatBalancer.top.calibrationAdjustment;
        _this2.heatBalancerForm.top.rangeHigh = settingsResponse.data.sensors.temperature.heatBalancer.top.rangeHigh;
        _this2.heatBalancerForm.top.rangeLow = settingsResponse.data.sensors.temperature.heatBalancer.top.rangeLow;

        _this2.heatBalancerForm.bottom.calibrationAdjustment = settingsResponse.data.sensors.temperature.heatBalancer.bottom.calibrationAdjustment;
        _this2.heatBalancerForm.bottom.rangeHigh = settingsResponse.data.sensors.temperature.heatBalancer.bottom.rangeHigh;
        _this2.heatBalancerForm.bottom.rangeLow = settingsResponse.data.sensors.temperature.heatBalancer.bottom.rangeLow;
      }));
    },
    getIOData: function getIOData() {
      var _this3 = this;

      _axios2.default.all([_io2.default.getIO(this.user.activeZone), _io2.default.getSettings(this.user.activeZone)]).then(_axios2.default.spread(function (IOResponse, SettingsResponse) {
        _this3.outdoorForm.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.outdoor.toFixed(1));
        _this3.domesticForm.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.domesticWater.toFixed(1));
        _this3.stackForm.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.stack.toFixed(1));
        _this3.returnLineForm.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.returnLine.toFixed(1));
        _this3.auxiliaryForm.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.aux.toFixed(1));
        _this3.heatBalancerForm.top.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.top.toFixed(1));
        _this3.heatBalancerForm.bottom.currentTemperature = _util2.default.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.bottom.toFixed(1));
        _this3.heatBalancerForm.difference = _util2.default.printTemperature((IOResponse.data.sensors.temperature.heatBalancer.top - IOResponse.data.sensors.temperature.heatBalancer.bottom).toFixed(1));
      }));
    }
  }
};

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    addZoneAlarm: function addZoneAlarm(_zoneID, _alarmTypeID, _name, _enabled, _threshold, _hysterisis) {
        return _axios2.default.post("/addZoneAlarm", {
            zoneID: _zoneID,
            alarmTypeID: _alarmTypeID,
            enabled: _enabled,
            threshold: _threshold,
            hysterisis: _hysterisis,
            name: _name
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    updateZoneAlarm: function updateZoneAlarm(_id, _name, _enabled, _threshold, _hysterisis) {
        return _axios2.default.post("/updateZoneAlarm", {
            id: _id,
            enabled: _enabled,
            threshold: _threshold,
            hysterisis: _hysterisis,
            name: _name
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    deleteZoneAlarm: function deleteZoneAlarm(_zoneAlarmID) {
        return _axios2.default.post("/deleteZoneAlarm", {
            id: _zoneAlarmID
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    getZoneAlarms: function getZoneAlarms(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        };
        return _axios2.default.post("/getZoneAlarms", { zoneID: _zoneID }, config);
    },
    getZoneAlarmLog: function getZoneAlarmLog(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        };
        return _axios2.default.post("/getZoneAlarmLog", { zoneID: _zoneID }, config);
    }
};

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    addZoneNote: function addZoneNote(_zoneID, _email, _notes) {
        return _axios2.default.post("/addZoneNote", {
            zoneID: _zoneID,
            email: _email,
            notes: _notes
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    editZoneNote: function editZoneNote(_zoneNoteID, _notes) {
        return _axios2.default.post("/editZoneNote", {
            zoneNoteID: _zoneNoteID,
            notes: _notes
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    deleteZoneNote: function deleteZoneNote(_zoneNoteID) {
        return _axios2.default.post("/deleteZoneNote", {
            zoneNoteID: _zoneNoteID
        }, {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        });
    },
    getZoneNotes: function getZoneNotes(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        };
        return _axios2.default.post("/getZoneNotes", { zoneID: _zoneID }, config);
    }
};

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(524);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(531);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(525);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(529);

var _vueRouter = __webpack_require__(532);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(523);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(214);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(522);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(527);

var _vueSession = __webpack_require__(533);

var _vueSession2 = _interopRequireDefault(_vueSession);

var _vueTables = __webpack_require__(534);

var _auth = __webpack_require__(316);

var _auth2 = _interopRequireDefault(_auth);

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _vueNumkeyboard = __webpack_require__(317);

var _vueNumkeyboard2 = _interopRequireDefault(_vueNumkeyboard);

__webpack_require__(528);

var _vueVisible = __webpack_require__(535);

var _vueVisible2 = _interopRequireDefault(_vueVisible);

var _vueLightTimeline = __webpack_require__(530);

var _vueLightTimeline2 = _interopRequireDefault(_vueLightTimeline);

var _en = __webpack_require__(526);

var _en2 = _interopRequireDefault(_en);

var _user = __webpack_require__(70);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = "https://variablevac.com:8443";

_vue2.default.use(_vueSession2.default);
_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueNumkeyboard2.default);
_vue2.default.use(_vueVisible2.default);
_vue2.default.use(_vueLightTimeline2.default);
_vue2.default.use(_auth2.default);
_vue2.default.use(_vueTables.ClientTable, {}, false, "bootstrap3", "default");

_vue2.default.prototype.$sysLock = true;

var router = new _vueRouter2.default({
  mode: "history",
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.name == "Callback") {

    next();
  } else if (router.app.$auth.isAuthenticated()) {
    console.log("authenticated");

    if (!router.app.$session.exists()) {
      router.app.$session.start();
      _user2.default.getUser(router.app.$auth.user.email).then(function (response) {
        if (response.data.error == null) {
          router.app.$session.start();
          router.app.$session.set("User", response.data);
          next();
        } else {
          router.app.$auth.login();
        }
      });
    } else {
      next();
    }
  } else {
    console.log("requesting login");
    router.app.$auth.login();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount("#app");

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(8);

var _axios2 = _interopRequireDefault(_axios);

var _auth = __webpack_require__(316);

var _auth2 = _interopRequireDefault(_auth);

var _https = __webpack_require__(1212);

var _https2 = _interopRequireDefault(_https);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var agent = new _https2.default.Agent({
  rejectUnauthorized: false
});

exports.default = {
  getUser: function getUser(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getUser", { email: _email }, config);
  },
  getZones: function getZones(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getZones", { email: _email }, config);
  },
  getZonesEx: function getZonesEx(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getZonesEx", { email: _email }, config);
  },
  getZone: function getZone(_deviceID) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getZone", { deviceID: _deviceID }, config);
  },
  getBoros: function getBoros() {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getBoros", {}, config);
  },
  switchZone: function switchZone(_zoneID, _email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/switchZone", { zoneID: _zoneID, email: _email }, config);
  },
  addZone: function addZone(_deviceID, _name, _gsd_id, _boro_id, _next_billing_at) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/addZone", { deviceID: _deviceID, name: _name, gsd_id: _gsd_id, boro_id: _boro_id, next_billing_at: _next_billing_at }, config);
  },
  updateZone: function updateZone(_deviceID, _name, _gsd_id, _boro_id, _next_billing_at) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/updateZone", { deviceID: _deviceID, name: _name, gsd_id: _gsd_id, boro_id: _boro_id, next_billing_at: _next_billing_at }, config);
  },
  deleteZone: function deleteZone(_deviceID) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/deleteZone", { deviceID: _deviceID }, config);
  },
  uploadZoneImage: function uploadZoneImage(_deviceID, image) {
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        httpsAgent: agent,
        "Content-Type": "multipart/form-data"
      }
    };
    var bodyFormData = new FormData();
    bodyFormData.set("deviceID", _deviceID);
    bodyFormData.append("image", image);
    return _axios2.default.post("/uploadZoneImage", bodyFormData, config);
  },
  getUsers: function getUsers() {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getUsers", {}, config);
  },
  addUser: function addUser(_email, _role, _zoneId, _password) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/addUser", {
      email: _email,
      role: _role,
      zoneId: _zoneId,
      password: _password
    }, config);
  },
  addExistingUserToZone: function addExistingUserToZone(_email, _zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/addExistingUserToZone", {
      email: _email,
      zoneId: _zoneId
    }, config);
  },
  deleteUser: function deleteUser(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/deleteUser", {
      email: _email.toLowerCase()
    }, config);
  },
  deleteUserAccessToZone: function deleteUserAccessToZone(_email, _zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/deleteUserAccessToZone", {
      email: _email.toLowerCase(),
      zoneId: _zoneId
    }, config);
  },
  getUserZoneAccess: function getUserZoneAccess(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getUserZoneAccess", {
      email: _email.toLowerCase()
    }, config);
  },
  getZoneUsers: function getZoneUsers(_zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getZoneUsers", {
      zoneId: _zoneId
    }, config);
  },
  getZoneLog: function getZoneLog(_zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getZoneLog", {
      zoneID: _zoneId
    }, config);
  },
  getUserBillingDue: function getUserBillingDue(_user) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/getUserBillingDue", {
      user: _user
    }, config);
  },
  updateUserNotifications: function updateUserNotifications(_email, _notifications) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    };
    return _axios2.default.post("/updateUserNotifications", {
      email: _email,
      notifications: _notifications
    }, config);
  }
};

/***/ })

},[622]);


// WEBPACK FOOTER //
// static/js/app.81378d76f3aa1202e8d1.js